// Board Exam - Care Planning and Documentation
// Complete file with 1 topic and questions

export const questions = {
  "1. Care Planning, Evaluation, and Documentation": [
    {
      id: 19100,
      question: "The dental hygiene care plan is best described as which of the following?",
      options: [
        "A list of procedures to be completed during appointments",
        "A written blueprint directing the dental hygienist and patient toward desired oral health outcomes",
        "A standardized protocol applied to all patients",
        "A document created solely by the dental hygienist"
      ],
      correct: "B"
    },
    {
      id: 19101,
      question: "Which ADHA Standard corresponds to the planning step of the dental hygiene process of care?",
      options: [
        "Standard 1",
        "Standard 2",
        "Standard 3",
        "Standard 4"
      ],
      correct: "C"
    },
    {
      id: 19102,
      question: "What is the primary purpose of planning in the dental hygiene process of care?",
      options: [
        "To schedule patient appointments efficiently",
        "To develop a strategy resulting in problem resolution, prevention, or health promotion",
        "To document services for insurance billing",
        "To comply with state regulations"
      ],
      correct: "B"
    },
    {
      id: 19103,
      question: "The term \"dental hygiene care plan\" rather than \"dental hygiene treatment plan\" is used to denote:",
      options: [
        "Services covered by insurance",
        "Only preventive services",
        "The broad range of preventive, educational, therapeutic, and support services",
        "Emergency care procedures"
      ],
      correct: "C"
    },
    {
      id: 19104,
      question: "Which of the following is included in a comprehensive dental treatment plan developed by the dentist?",
      options: [
        "Only restorative procedures",
        "The dental diagnosis, therapy phases, and prognosis",
        "Dental hygiene services exclusively",
        "Patient insurance information"
      ],
      correct: "B"
    },
    {
      id: 19105,
      question: "Interprofessional collaboration (IPC) is best defined as:",
      options: [
        "Dental hygienists working independently",
        "Dentists supervising all dental hygiene activities",
        "Coordinated care by an interdisciplinary patient care team",
        "Referrals to specialists only"
      ],
      correct: "C"
    },
    {
      id: 19106,
      question: "What components must a dental hygiene care plan specify?",
      options: [
        "Only the appointment schedule",
        "Dental hygiene diagnoses, goals, interventions, and appointment schedule",
        "Insurance coverage details",
        "The dentist\'s treatment plan only"
      ],
      correct: "B"
    },
    {
      id: 19107,
      question: "When prioritizing dental hygiene diagnoses, which criterion is most important?",
      options: [
        "The alphabetical order of diagnoses",
        "The degree to which the diagnosis threatens patient well-being",
        "The cost of treatment",
        "The time required for treatment"
      ],
      correct: "B"
    },
    {
      id: 19108,
      question: "A care plan goal must include all of the following components EXCEPT:",
      options: [
        "Subject",
        "Verb",
        "Insurance code",
        "Time dimension"
      ],
      correct: "C"
    },
    {
      id: 19109,
      question: "Which type of goal addresses desired changes in patient values, beliefs, and attitudes?",
      options: [
        "Cognitive goal",
        "Psychomotor goal",
        "Affective goal",
        "Clinical goal"
      ],
      correct: "C"
    },
    {
      id: 19110,
      question: "A cognitive goal focuses on:",
      options: [
        "Patient skill development",
        "Increase in patient knowledge and understanding",
        "Changes in patient attitudes",
        "Clinical health outcomes"
      ],
      correct: "B"
    },
    {
      id: 19111,
      question: "Which goal category defines the desired clinical outcome of care?",
      options: [
        "Cognitive goal",
        "Psychomotor goal",
        "Affective goal",
        "Oral health status goal"
      ],
      correct: "D"
    },
    {
      id: 19112,
      question: "What is the philosophical difference between the Human Needs Conceptual Model and the OHRQL Model regarding goal setting?",
      options: [
        "Only the HN Model uses goals",
        "The HN Model sets goals first, while OHRQL develops treatment strategies first",
        "They use identical sequencing",
        "Neither model uses formal goals"
      ],
      correct: "B"
    },
    {
      id: 19113,
      question: "Dental hygiene interventions are best described as:",
      options: [
        "Only therapeutic services",
        "Evidence-based strategies, services, treatments, products, and referrals",
        "Procedures performed exclusively by dentists",
        "Patient education materials"
      ],
      correct: "B"
    },
    {
      id: 19114,
      question: "When establishing an appointment schedule, which factor should be considered?",
      options: [
        "Only the clinician\'s availability",
        "Time needed for interventions, patient comfort, and evaluation",
        "Insurance authorization only",
        "Office closing times"
      ],
      correct: "B"
    },
    {
      id: 19115,
      question: "Informed consent must include all of the following EXCEPT:",
      options: [
        "Nature of the condition",
        "Proposed care plan",
        "Guarantee of success",
        "Risks of not receiving care"
      ],
      correct: "C"
    },
    {
      id: 19116,
      question: "For informed consent, the patient must:",
      options: [
        "Only sign a form",
        "Be knowledgeable, have enough information, and give permission",
        "Agree without discussion",
        "Accept whatever the clinician recommends"
      ],
      correct: "B"
    },
    {
      id: 19117,
      question: "Informed refusal occurs when:",
      options: [
        "The patient arrives late for appointments",
        "The patient declines all or part of the proposed care plan",
        "The clinician refuses to treat the patient",
        "Insurance denies coverage"
      ],
      correct: "B"
    },
    {
      id: 19118,
      question: "If a patient refuses recommended care, the dental hygienist should:",
      options: [
        "Discharge the patient immediately",
        "Engage in conversation, listen, and have the patient sign an informed refusal",
        "Proceed with treatment anyway",
        "Report the patient to authorities"
      ],
      correct: "B"
    },
    {
      id: 19119,
      question: "The goal of ADHA Standard 5 (evaluation) is to:",
      options: [
        "Complete documentation",
        "Measure the extent to which the patient achieved defined goals",
        "Schedule the next appointment",
        "Bill for services"
      ],
      correct: "B"
    },
    {
      id: 19120,
      question: "Ongoing monitoring during implementation involves:",
      options: [
        "Waiting until treatment is complete to assess progress",
        "Continual review and reinforcement of patient progress",
        "Only checking at the final appointment",
        "Monthly phone calls to the patient"
      ],
      correct: "B"
    },
    {
      id: 19121,
      question: "When a care plan goal is not met, the dental hygienist should:",
      options: [
        "Terminate the patient relationship",
        "Ignore the unmet goal",
        "Reassess and modify the care plan",
        "Blame the patient"
      ],
      correct: "C"
    },
    {
      id: 19122,
      question: "What are the possible outcomes when evaluating a care plan goal?",
      options: [
        "Only \"met\" or \"not met\"",
        "Met, partially met, or not met",
        "Pass or fail",
        "Satisfactory or unsatisfactory"
      ],
      correct: "B"
    },
    {
      id: 19123,
      question: "A dental hygiene prognosis is contingent on all of the following EXCEPT:",
      options: [
        "Overall appraisal of evaluative statements",
        "Patient\'s continued adherence to self-care",
        "The dental hygienist\'s years of experience",
        "Systemic health and environmental factors"
      ],
      correct: "C"
    },
    {
      id: 19124,
      question: "A favorable prognosis occurs when:",
      options: [
        "All appointments are completed",
        "Goals have been met and risk for disease recurrence is low",
        "The patient pays in full",
        "Treatment takes less time than expected"
      ],
      correct: "B"
    },
    {
      id: 19125,
      question: "Continued-care appointments are typically scheduled at intervals of:",
      options: [
        "1 week to 1 month",
        "2 to 12 months",
        "12 to 24 months",
        "Only when the patient calls"
      ],
      correct: "B"
    },
    {
      id: 19126,
      question: "At a continued-care visit, evaluation should measure:",
      options: [
        "Only new problems",
        "Continued attainment of previous care plan goals and identification of new needs",
        "Whether the patient brought payment",
        "Office satisfaction surveys only"
      ],
      correct: "B"
    },
    {
      id: 19127,
      question: "ADHA Standard 6 addresses which aspect of care?",
      options: [
        "Assessment",
        "Diagnosis",
        "Implementation",
        "Documentation"
      ],
      correct: "D"
    },
    {
      id: 19128,
      question: "Complete and accurate documentation should include all of the following EXCEPT:",
      options: [
        "Collected data and care plan",
        "Treatment outcomes and prognosis",
        "Personal opinions about the patient",
        "Patient consent for treatment"
      ],
      correct: "C"
    },
    {
      id: 19129,
      question: "Documentation goals include all EXCEPT:",
      options: [
        "Maintaining continuity of care",
        "Providing communication among healthcare team",
        "Guaranteeing no malpractice claims",
        "Minimizing practitioner risk"
      ],
      correct: "C"
    },
    {
      id: 19130,
      question: "Which dental procedure code indicates oral hygiene instruction?",
      options: [
        "D1110",
        "D1206",
        "D1330",
        "D4910"
      ],
      correct: "C"
    },
    {
      id: 19131,
      question: "Prophylaxis for an adult is documented using which CDT code?",
      options: [
        "D1110",
        "D1120",
        "D1330",
        "D4341"
      ],
      correct: "A"
    },
    {
      id: 19132,
      question: "Periodontal maintenance is indicated by which code?",
      options: [
        "D4341",
        "D4346",
        "D4910",
        "D1110"
      ],
      correct: "C"
    },
    {
      id: 19133,
      question: "Scaling and root planing (four or more teeth per quadrant) uses which code?",
      options: [
        "D1110",
        "D4341",
        "D4346",
        "D4910"
      ],
      correct: "B"
    },
    {
      id: 19134,
      question: "According to the chapter, what percentage of dental hygienist services should focus on prevention?",
      options: [
        "25%",
        "50%",
        "Varies based on patient needs",
        "100%"
      ],
      correct: "C"
    },
    {
      id: 19135,
      question: "The Human Needs Conceptual Model identifies how many human needs related to dental hygiene care?",
      options: [
        "Five",
        "Six",
        "Eight",
        "Ten"
      ],
      correct: "C"
    },
    {
      id: 19136,
      question: "Which is NOT one of the eight human needs in the HN Conceptual Model?",
      options: [
        "Protection from health risks",
        "Financial security",
        "Freedom from pain",
        "Wholesome facial image"
      ],
      correct: "B"
    },
    {
      id: 19137,
      question: "In the HN Model, the diagnosis format includes all EXCEPT:",
      options: [
        "Unmet human need",
        "Etiology",
        "Insurance authorization",
        "Signs and symptoms"
      ],
      correct: "C"
    },
    {
      id: 19138,
      question: "The OHRQL Model was introduced in which year?",
      options: [
        "1985",
        "1998",
        "2005",
        "2010"
      ],
      correct: "B"
    },
    {
      id: 19139,
      question: "According to WHO\'s definition referenced in the OHRQL Model, health includes:",
      options: [
        "Only physical well-being",
        "Physical and mental well-being only",
        "Complete physical, mental, and social well-being",
        "Absence of disease only"
      ],
      correct: "C"
    },
    {
      id: 19140,
      question: "When writing a dental hygiene diagnosis using the HN Model, what follows \"due to\"?",
      options: [
        "The patient\'s name",
        "The etiology or causative factors",
        "The treatment plan",
        "The prognosis"
      ],
      correct: "B"
    },
    {
      id: 19141,
      question: "In care planning, patient-centered goals address:",
      options: [
        "Only clinical outcomes",
        "Behaviors or barriers contributing to unmet needs",
        "Insurance requirements",
        "Office scheduling needs"
      ],
      correct: "B"
    },
    {
      id: 19142,
      question: "Which is an example of a psychomotor goal?",
      options: [
        "Patient will explain the disease process",
        "Patient will demonstrate proper flossing technique",
        "Patient will value oral health",
        "Patient will eliminate gingival inflammation"
      ],
      correct: "B"
    },
    {
      id: 19143,
      question: "When should self-care education be incorporated into appointments?",
      options: [
        "Only at the first visit",
        "Only at the last visit",
        "In each visit",
        "Only when time permits"
      ],
      correct: "C"
    },
    {
      id: 19144,
      question: "What is a key characteristic of a well-written dental hygiene care plan?",
      options: [
        "It is the same for all patients",
        "It reflects goals of disease prevention and health promotion",
        "It focuses only on treatment procedures",
        "It is written exclusively by the dentist"
      ],
      correct: "B"
    },
    {
      id: 19145,
      question: "The care plan should be compatible with:",
      options: [
        "Office policies only",
        "The dental treatment plan prepared by the dentist",
        "Insurance coverage exclusively",
        "National treatment guidelines only"
      ],
      correct: "B"
    },
    {
      id: 19146,
      question: "How should priorities be established when multiple diagnoses exist?",
      options: [
        "In alphabetical order",
        "By cost of treatment",
        "By degree of threat to patient well-being and ability to address simultaneously",
        "By patient preference only"
      ],
      correct: "C"
    },
    {
      id: 19147,
      question: "According to the chapter, meeting the patient\'s need for safety typically requires:",
      options: [
        "No special considerations",
        "Preliminary emergency care in some instances",
        "Always postponing treatment",
        "Immediate referral to a physician"
      ],
      correct: "B"
    },
    {
      id: 19148,
      question: "When presenting the care plan to the patient, the dental hygienist should:",
      options: [
        "Simply hand the patient a written plan",
        "Establish a collaborative relationship and engage in discussion",
        "Tell the patient what will be done without discussion",
        "Have the dentist present all information"
      ],
      correct: "B"
    },
    {
      id: 19149,
      question: "If after discussion a patient makes an informed refusal, what should be documented?",
      options: [
        "Nothing, to avoid legal issues",
        "Only that the patient refused",
        "A detailed informed refusal signed by the patient",
        "A complaint against the patient"
      ],
      correct: "C"
    },
    {
      id: 19150,
      question: "What is the recommended approach if a patient requests care that is unwarranted or dangerous?",
      options: [
        "Provide the care as requested",
        "Refuse and encourage seeking a second opinion",
        "Report the patient to authorities",
        "Agree but document concerns"
      ],
      correct: "B"
    },
    {
      id: 19151,
      question: "The Canadian Dental Hygienists Association refers to the dental hygiene process framework as:",
      options: [
        "ADHA Standards",
        "Dental Hygiene Process of Care (DHPC)",
        "Canadian Care Protocol",
        "Treatment Planning Guidelines"
      ],
      correct: "B"
    },
    {
      id: 19152,
      question: "Which factor should NOT influence how priorities are established?",
      options: [
        "Patient values and beliefs",
        "Healthcare provider philosophy",
        "The dental hygienist\'s personal preferences",
        "Patient health status"
      ],
      correct: "C"
    },
    {
      id: 19153,
      question: "Evidence-based practice integrates all of the following EXCEPT:",
      options: [
        "Scientific evidence",
        "Clinical expertise",
        "Patient values",
        "Insurance reimbursement rates"
      ],
      correct: "D"
    },
    {
      id: 19154,
      question: "According to the chapter, motivational interviewing is described as:",
      options: [
        "An authoritarian approach",
        "Collaborative and person-centered to elicit motivation for change",
        "Prescriptive advice giving",
        "A one-time conversation"
      ],
      correct: "B"
    },
    {
      id: 19155,
      question: "What percentage of health outcomes are attributed to social determinants of health?",
      options: [
        "10-20%",
        "30-55%",
        "60-75%",
        "80-90%"
      ],
      correct: "B"
    },
    {
      id: 19156,
      question: "How many U.S. states permitted direct access at the time the chapter was written?",
      options: [
        "25",
        "32",
        "42",
        "50"
      ],
      correct: "C"
    },
    {
      id: 19157,
      question: "Which states authorized dental hygiene diagnosis in their practice acts as mentioned in the chapter?",
      options: [
        "California and New York",
        "Oregon and Colorado",
        "Texas and Florida",
        "Massachusetts and Illinois"
      ],
      correct: "B"
    },
    {
      id: 19158,
      question: "When did CODA remove dental hygiene diagnosis from standards?",
      options: [
        "January 1, 1995",
        "January 1, 2000",
        "January 1, 2010",
        "January 1, 2015"
      ],
      correct: "C"
    },
    {
      id: 19159,
      question: "The current CODA definition (2022) describes dental hygiene diagnosis as:",
      options: [
        "Identification of diseases",
        "Identification of oral health problems the dental hygienist is qualified and licensed to treat",
        "Medical diagnosis translation",
        "Dental treatment planning"
      ],
      correct: "B"
    },
    {
      id: 19160,
      question: "Person-centered care views people as:",
      options: [
        "Patients only",
        "Equal partners in planning and developing care",
        "Recipients of prescribed treatment",
        "Subjects of clinical procedures"
      ],
      correct: "B"
    },
    {
      id: 19161,
      question: "What are the five phases of the dental hygiene process of care?",
      options: [
        "Planning, Treatment, Follow-up, Billing, Referral",
        "Assessment, Diagnosis, Planning, Implementation, Evaluation",
        "Scheduling, Cleaning, Polishing, Fluoride, Dismissal",
        "Greeting, Seating, Treating, Educating, Scheduling"
      ],
      correct: "B"
    },
    {
      id: 19162,
      question: "Reassessment occurs during which phases of the dental hygiene process?",
      options: [
        "Only during assessment",
        "Only during evaluation",
        "Throughout all phases",
        "Only at the initial appointment"
      ],
      correct: "C"
    },
    {
      id: 19163,
      question: "Which phase includes biopsychosocial data collection?",
      options: [
        "Planning only",
        "Assessment",
        "Implementation only",
        "Documentation only"
      ],
      correct: "B"
    },
    {
      id: 19164,
      question: "In Case Study 22.1, what was the patient\'s chief complaint?",
      options: [
        "Tooth pain",
        "Not having been to the dentist in 6+ years and recently diagnosed with diabetes",
        "Broken restoration",
        "Cosmetic concerns"
      ],
      correct: "B"
    },
    {
      id: 19165,
      question: "What was the patient\'s HbA1c level in Case Study 22.1?",
      options: [
        "5.5%",
        "6.5%",
        "7.5%",
        "8.5%"
      ],
      correct: "C"
    },
    {
      id: 19166,
      question: "Which medications was the patient taking in Case Study 22.1?",
      options: [
        "Insulin only",
        "Metformin and Zaroxolyn",
        "Aspirin and statins",
        "Antibiotics"
      ],
      correct: "B"
    },
    {
      id: 19167,
      question: "What was the patient\'s periodontal classification in Case Study 22.1?",
      options: [
        "Stage I, Grade A",
        "Stage II, Grade B",
        "Stage III, Grade B",
        "Stage IV, Grade C"
      ],
      correct: "C"
    },
    {
      id: 19168,
      question: "Which teeth were missing in Case Study 22.1?",
      options: [
        "#1, #16, #17, #32",
        "#18, #19, #30, #31",
        "All third molars",
        "#2, #15, #18, #31"
      ],
      correct: "B"
    },
    {
      id: 19169,
      question: "What was the patient\'s bleeding index (BI) in Case Study 22.1?",
      options: [
        "45%",
        "58%",
        "68%",
        "78%"
      ],
      correct: "C"
    },
    {
      id: 19170,
      question: "What was the plaque score in Case Study 22.1?",
      options: [
        "8%",
        "18%",
        "28%",
        "38%"
      ],
      correct: "B"
    },
    {
      id: 19171,
      question: "Which unmet need addressed the patient\'s diabetes and hypertension in Case Study 22.1?",
      options: [
        "Wholesome facial image",
        "Freedom from pain",
        "Protection from health risks",
        "Biologically sound dentition"
      ],
      correct: "C"
    },
    {
      id: 19172,
      question: "For the unmet need of skin and mucous membrane integrity, what was one of the goals?",
      options: [
        "Schedule dental appointments",
        "Reduce probing depths of 5mm or greater by 1mm or more",
        "Increase plaque score",
        "Avoid all dental treatment"
      ],
      correct: "B"
    },
    {
      id: 19173,
      question: "What intervention was recommended for caries risk in Case Study 22.1?",
      options: [
        "No treatment needed",
        "1.1% NaF toothpaste and xylitol gum",
        "Antibiotics only",
        "Immediate extractions"
      ],
      correct: "B"
    },
    {
      id: 19174,
      question: "How was the short-term prognosis described in Case Study 22.1?",
      options: [
        "Poor",
        "Fair",
        "Good",
        "Excellent"
      ],
      correct: "C"
    },
    {
      id: 19175,
      question: "Why was the long-term prognosis guarded in Case Study 22.1?",
      options: [
        "Patient non-compliance",
        "Diabetes HbA1c 7.5%, age, and localized bone loss",
        "Financial constraints",
        "Language barriers"
      ],
      correct: "B"
    },
    {
      id: 19176,
      question: "What was the recommended continued care interval in Case Study 22.1?",
      options: [
        "1 month",
        "3 months",
        "6 months",
        "12 months"
      ],
      correct: "B"
    },
    {
      id: 19177,
      question: "Which appointment phase includes patient education and self-care instruction?",
      options: [
        "Preliminary Phase only",
        "Phase I Therapy only",
        "Phase I, Phase IV, and throughout care",
        "Phase III only"
      ],
      correct: "C"
    },
    {
      id: 19178,
      question: "What does Phase I evaluation include?",
      options: [
        "Only probing depths",
        "Inquiry of health changes, oral hygiene assessment, and outcome evaluation",
        "Financial review only",
        "Scheduling next year\'s appointment"
      ],
      correct: "B"
    },
    {
      id: 19179,
      question: "Phase II therapy primarily involves:",
      options: [
        "Prophylaxis",
        "Patient education",
        "Periodontal surgery and endodontics",
        "Orthodontics only"
      ],
      correct: "C"
    },
    {
      id: 19180,
      question: "Phase III therapy focuses on:",
      options: [
        "Assessment",
        "Periodontal surgery",
        "Final restorative care and prosthodontics",
        "Maintenance only"
      ],
      correct: "C"
    },
    {
      id: 19181,
      question: "Phase IV therapy is also known as:",
      options: [
        "Initial therapy",
        "Surgical phase",
        "Restorative phase",
        "Maintenance phase"
      ],
      correct: "D"
    },
    {
      id: 19182,
      question: "What does a comprehensive periodontal examination in Phase IV include?",
      options: [
        "Only visual inspection",
        "Health status inquiry, examination, charting, and risk assessment",
        "X-rays only",
        "Insurance verification"
      ],
      correct: "B"
    },
    {
      id: 19183,
      question: "According to Table 23.1, which services may be performed by the dental hygienist?",
      options: [
        "Endodontic therapy",
        "Extractions",
        "Patient education, debridement, and fluoride therapy",
        "Surgical periodontal procedures"
      ],
      correct: "C"
    },
    {
      id: 19184,
      question: "Dietary guidance provided by dental hygienists focuses on:",
      options: [
        "Weight loss only",
        "Caries risk management, prevention, and tissue healing",
        "Food allergies only",
        "Nutritional supplements exclusively"
      ],
      correct: "B"
    },
    {
      id: 19185,
      question: "Smoking cessation counseling is included in which phase?",
      options: [
        "Preliminary Phase only",
        "Phase I Therapy",
        "Phase III only",
        "Not included in dental hygiene care"
      ],
      correct: "B"
    },
    {
      id: 19186,
      question: "Coronal polishing is included as a dental hygiene service in:",
      options: [
        "Preliminary Phase",
        "Phase I Therapy",
        "Phase II Therapy",
        "All phases as needed"
      ],
      correct: "B"
    },
    {
      id: 19187,
      question: "What does the modified Gingival Index (GI) of 3 indicate?",
      options: [
        "Health",
        "Mild inflammation",
        "Moderate inflammation",
        "Severe inflammation"
      ],
      correct: "C"
    },
    {
      id: 19188,
      question: "When should fluoride varnish be applied according to dental hygiene care planning?",
      options: [
        "Only at initial visits",
        "Never",
        "As part of caries risk management and prevention strategies",
        "Only for children"
      ],
      correct: "C"
    },
    {
      id: 19189,
      question: "What is the purpose of a preprocedural rinse with chlorhexidine?",
      options: [
        "To freshen breath",
        "To reduce microorganisms",
        "To numb tissues",
        "To whiten teeth"
      ],
      correct: "B"
    },
    {
      id: 19190,
      question: "Which index measures the patient\'s plaque accumulation?",
      options: [
        "Bleeding Index",
        "Gingival Index",
        "Plaque Index",
        "Calculus Index"
      ],
      correct: "C"
    },
    {
      id: 19191,
      question: "What does a Plaque Index of 90% indicate?",
      options: [
        "Excellent oral hygiene",
        "Good oral hygiene",
        "Poor oral hygiene",
        "Average oral hygiene"
      ],
      correct: "C"
    },
    {
      id: 19192,
      question: "In critical thinking scenario B, what was Eileen\'s chief concern?",
      options: [
        "Tooth pain",
        "Discolored teeth and bleeding gums",
        "Missing teeth",
        "Bad breath"
      ],
      correct: "B"
    },
    {
      id: 19193,
      question: "What was Eileen\'s caries risk assessment?",
      options: [
        "Low risk",
        "Moderate risk",
        "High risk",
        "No risk"
      ],
      correct: "B"
    },
    {
      id: 19194,
      question: "What was Eileen\'s modified GI score?",
      options: [
        "1",
        "2",
        "3",
        "4"
      ],
      correct: "C"
    },
    {
      id: 19195,
      question: "Eileen\'s probing depths were:",
      options: [
        "1-2mm",
        "2-3mm",
        "3-4mm",
        "5-6mm"
      ],
      correct: "C"
    },
    {
      id: 19196,
      question: "What was Eileen\'s bleeding index?",
      options: [
        "53%",
        "63%",
        "73%",
        "83%"
      ],
      correct: "C"
    },
    {
      id: 19197,
      question: "Eileen\'s plaque index was:",
      options: [
        "44%",
        "54%",
        "64%",
        "74%"
      ],
      correct: "C"
    },
    {
      id: 19198,
      question: "What type of stain did Eileen present with?",
      options: [
        "Green stain",
        "Brown extrinsic stain",
        "Black line stain",
        "No stain"
      ],
      correct: "B"
    },
    {
      id: 19199,
      question: "For generalized moderate gingivitis, which diagnosis model provides specific guidance?",
      options: [
        "Medical model only",
        "Both Human Needs and OHRQL models",
        "Nursing model only",
        "No model applies"
      ],
      correct: "B"
    },
    {
      id: 19200,
      question: "When formulating intervention strategies, what must be considered?",
      options: [
        "Only the symptoms",
        "The causative factors and barriers to achieving health",
        "The fee schedule only",
        "Office hours"
      ],
      correct: "B"
    },
    {
      id: 19201,
      question: "A patient brushing once daily with a medium bristle brush represents:",
      options: [
        "Optimal oral hygiene",
        "A barrier to achieving oral health",
        "Acceptable practice",
        "No concern"
      ],
      correct: "B"
    },
    {
      id: 19202,
      question: "Which is an example of a sociocultural barrier to oral health?",
      options: [
        "Lack of dental insurance",
        "Seeking care not being a cultural norm",
        "Fear of needles",
        "Busy schedule"
      ],
      correct: "B"
    },
    {
      id: 19203,
      question: "When a patient reports difficulty with flossing due to calculus, the appropriate response is:",
      options: [
        "Tell them to stop flossing",
        "Acknowledge their observation and explain access will improve as calculus is removed",
        "Ignore the comment",
        "Recommend they never floss"
      ],
      correct: "B"
    },
    {
      id: 19204,
      question: "What is the appropriate response when a patient is disappointed that plaque is present despite effort?",
      options: [
        "Criticize their technique",
        "Provide positive feedback for commitment and progress",
        "Say nothing",
        "Recommend giving up"
      ],
      correct: "B"
    },
    {
      id: 19205,
      question: "At a Phase I reevaluation, if goals are partially met, the dental hygienist should:",
      options: [
        "Terminate care",
        "Discharge the patient",
        "Continue care and reinforce strategies in areas needing improvement",
        "Start over completely"
      ],
      correct: "C"
    },
    {
      id: 19206,
      question: "A localized 7mm pocket depth at initial examination requires:",
      options: [
        "No treatment",
        "Monitoring only",
        "Periodontal therapy and possible specialist referral",
        "Immediate extraction"
      ],
      correct: "C"
    },
    {
      id: 19207,
      question: "When a patient\'s blood pressure is 130/90, this is classified as:",
      options: [
        "Normal",
        "Stage 1 systolic, Stage 2 diastolic hypertension",
        "Stage 2 hypertension",
        "Hypotension"
      ],
      correct: "B"
    },
    {
      id: 19208,
      question: "The bidirectional relationship between diabetes and periodontitis means:",
      options: [
        "They are unrelated",
        "Each condition can affect the other",
        "Only diabetes affects periodontitis",
        "Only periodontitis affects diabetes"
      ],
      correct: "B"
    },
    {
      id: 19209,
      question: "What HbA1c level indicates good diabetes control?",
      options: [
        "Below 5.7%",
        "Below 6.5%",
        "Below 7%",
        "Below 9%"
      ],
      correct: "C"
    },
    {
      id: 19210,
      question: "Xerostomia can be caused by:",
      options: [
        "Excessive water intake",
        "Certain medications like metformin and Zaroxolyn",
        "Too much saliva",
        "Frequent dental visits"
      ],
      correct: "B"
    },
    {
      id: 19211,
      question: "For a patient with xerostomia, appropriate recommendations include:",
      options: [
        "Avoid all fluids",
        "OTC saliva stimulating agents and xylitol gum",
        "Increase sugar intake",
        "Stop all medications"
      ],
      correct: "B"
    },
    {
      id: 19212,
      question: "A Class I molar relationship indicates:",
      options: [
        "Severe malocclusion",
        "Normal occlusion",
        "Missing molars",
        "Overbite"
      ],
      correct: "B"
    },
    {
      id: 19213,
      question: "What does a 2mm overbite represent?",
      options: [
        "Severe overbite",
        "Moderate overbite at 25%",
        "No overbite",
        "Underbite"
      ],
      correct: "B"
    },
    {
      id: 19214,
      question: "Furcation involvement F2 means:",
      options: [
        "No furcation involvement",
        "Incipient furcation involvement",
        "Moderate furcation involvement",
        "Through-and-through involvement"
      ],
      correct: "C"
    },
    {
      id: 19215,
      question: "When clinical attachment loss cannot be accurately measured due to calculus, the dental hygienist should:",
      options: [
        "Guess the measurement",
        "Document inability to measure accurately and reassess after calculus removal",
        "Skip the measurement",
        "Record zero"
      ],
      correct: "B"
    },
    {
      id: 19216,
      question: "Stage III periodontitis with Grade C indicates:",
      options: [
        "Mild disease, slow progression",
        "Moderate disease, moderate progression",
        "Severe disease, rapid progression",
        "Health"
      ],
      correct: "C"
    },
    {
      id: 19217,
      question: "Generalized horizontal bone loss means:",
      options: [
        "No bone loss",
        "Bone loss affecting most teeth in a similar pattern",
        "Bone loss in one area only",
        "Vertical bone defects"
      ],
      correct: "B"
    },
    {
      id: 19218,
      question: "The phrase \"patient will demonstrate\" in a goal indicates which type of goal?",
      options: [
        "Cognitive",
        "Psychomotor",
        "Affective",
        "Clinical"
      ],
      correct: "B"
    },
    {
      id: 19219,
      question: "The phrase \"patient will describe\" in a goal indicates which type of goal?",
      options: [
        "Cognitive",
        "Psychomotor",
        "Affective",
        "Clinical"
      ],
      correct: "A"
    },
    {
      id: 19220,
      question: "The phrase \"patient will report\" typically indicates which type of goal?",
      options: [
        "Cognitive",
        "Psychomotor",
        "Affective",
        "Could be any patient-centered goal"
      ],
      correct: "D"
    },
    {
      id: 19221,
      question: "The phrase \"patient will eliminate gingival inflammation\" indicates which type of goal?",
      options: [
        "Cognitive",
        "Psychomotor",
        "Affective",
        "Oral health status"
      ],
      correct: "D"
    },
    {
      id: 19222,
      question: "When evaluating goals, \"goal met\" means:",
      options: [
        "Partial achievement",
        "Complete achievement of the stated goal",
        "No achievement",
        "Goal was unnecessary"
      ],
      correct: "B"
    },
    {
      id: 19223,
      question: "\"Goal partially met\" indicates:",
      options: [
        "Complete failure",
        "Some progress toward the goal but not fully achieved",
        "No progress",
        "Goal exceeded"
      ],
      correct: "B"
    },
    {
      id: 19224,
      question: "\"Goal not met\" means:",
      options: [
        "The goal was partially achieved",
        "The goal was exceeded",
        "Little to no progress toward achieving the goal",
        "The goal was inappropriate"
      ],
      correct: "C"
    },
    {
      id: 19225,
      question: "When a goal is not met, the care plan should be:",
      options: [
        "Abandoned",
        "Modified after reassessment",
        "Continued without changes",
        "Ignored"
      ],
      correct: "B"
    },
    {
      id: 19226,
      question: "A favorable prognosis with low risk for disease recurrence typically results in a continued care interval of:",
      options: [
        "1 month",
        "3 months",
        "6 months",
        "12 months"
      ],
      correct: "C"
    },
    {
      id: 19227,
      question: "A guarded prognosis with moderate to high risk for disease recurrence typically results in a continued care interval of:",
      options: [
        "1-3 months",
        "6 months",
        "12 months",
        "24 months"
      ],
      correct: "A"
    },
    {
      id: 19228,
      question: "Electronic health records (EHR) support which goals?",
      options: [
        "Only billing efficiency",
        "Continuity of care and communication among providers",
        "Reducing patient visits",
        "Eliminating the need for documentation"
      ],
      correct: "B"
    },
    {
      id: 19229,
      question: "Documentation must be:",
      options: [
        "Brief and vague",
        "Accurate, factual, objective, and detailed",
        "Written by anyone in the office",
        "Optional"
      ],
      correct: "B"
    },
    {
      id: 19230,
      question: "Each documentation entry should include:",
      options: [
        "Patient\'s social security number",
        "Date of service and signature of provider who performed the service",
        "Insurance information only",
        "Office gossip"
      ],
      correct: "B"
    },
    {
      id: 19231,
      question: "Abbreviations in documentation should be:",
      options: [
        "Used extensively",
        "Made up as needed",
        "Limited to ensure understanding",
        "Never used"
      ],
      correct: "C"
    },
    {
      id: 19232,
      question: "Documented evidence of patient-centered care provides:",
      options: [
        "No legal protection",
        "The best defense against accusations of negligence",
        "Proof of insurance fraud",
        "Entertainment value"
      ],
      correct: "B"
    },
    {
      id: 19233,
      question: "What is a customized electronic note?",
      options: [
        "A handwritten note",
        "A note designed by the healthcare facility for frequently used entries",
        "A note from the patient",
        "An insurance form"
      ],
      correct: "B"
    },
    {
      id: 19234,
      question: "CDT codes are defined by:",
      options: [
        "Each dental office",
        "The American Dental Association",
        "Insurance companies",
        "State boards"
      ],
      correct: "B"
    },
    {
      id: 19235,
      question: "Code D0180 indicates:",
      options: [
        "Prophylaxis",
        "Comprehensive periodontal evaluation",
        "Fluoride application",
        "Extraction"
      ],
      correct: "B"
    },
    {
      id: 19236,
      question: "Code D0210 indicates:",
      options: [
        "Single periapical radiograph",
        "Bitewing radiographs",
        "Intraoral complete series of radiographic images",
        "Panoramic radiograph"
      ],
      correct: "C"
    },
    {
      id: 19237,
      question: "Code D0603 indicates:",
      options: [
        "Periodontal maintenance",
        "Caries risk assessment and documentation",
        "Oral cancer screening",
        "Dietary counseling"
      ],
      correct: "B"
    },
    {
      id: 19238,
      question: "Code D4346 is used for:",
      options: [
        "Prophylaxis",
        "Scaling in presence of generalized moderate/severe inflammation (no periodontitis)",
        "Scaling and root planing",
        "Periodontal surgery"
      ],
      correct: "B"
    },
    {
      id: 19239,
      question: "The main difference between D4346 and D4341 is:",
      options: [
        "Number of teeth",
        "Presence or absence of periodontitis",
        "Type of instruments used",
        "Cost"
      ],
      correct: "B"
    },
    {
      id: 19240,
      question: "In the case documentation example, why was chlorhexidine used as a preprocedural rinse?",
      options: [
        "To whiten teeth",
        "To reduce microorganisms",
        "As a flavor enhancer",
        "To test for allergies"
      ],
      correct: "B"
    },
    {
      id: 19241,
      question: "What does FMS stand for in the documentation?",
      options: [
        "Full Mouth Scaling",
        "Full Mouth Series (radiographs)",
        "First Molar Section",
        "Fluoride Management System"
      ],
      correct: "B"
    },
    {
      id: 19242,
      question: "What does BW stand for in dental documentation?",
      options: [
        "Body Weight",
        "Bitewing radiographs",
        "Both Ways",
        "Bone Width"
      ],
      correct: "B"
    },
    {
      id: 19243,
      question: "What does EOE stand for?",
      options: [
        "End of Examination",
        "Extraoral Examination",
        "Evaluation of Everything",
        "Emergency Oral Evaluation"
      ],
      correct: "B"
    },
    {
      id: 19244,
      question: "What does IOE stand for?",
      options: [
        "Initial Oral Evaluation",
        "Intraoral Examination",
        "Inside Oral Exam",
        "Immediate Operative Emergency"
      ],
      correct: "B"
    },
    {
      id: 19245,
      question: "What does CAL stand for in periodontal documentation?",
      options: [
        "Calculus Assessment Level",
        "Clinical Attachment Loss",
        "Comprehensive Annual Listing",
        "Cavity Assessment Location"
      ],
      correct: "B"
    },
    {
      id: 19246,
      question: "In the documentation, \"Q1 and Q4\" refers to:",
      options: [
        "Questions 1 and 4",
        "Quadrants 1 and 4",
        "Quarters 1 and 4",
        "Quality measures 1 and 4"
      ],
      correct: "B"
    },
    {
      id: 19247,
      question: "What does \"LA\" stand for in treatment documentation?",
      options: [
        "Los Angeles",
        "Local Anesthesia",
        "Light Abrasion",
        "Long Appointment"
      ],
      correct: "B"
    },
    {
      id: 19248,
      question: "What is the purpose of postoperative instructions?",
      options: [
        "To bill for additional services",
        "To inform the patient of expected healing and care after treatment",
        "To schedule the next appointment",
        "To collect payment"
      ],
      correct: "B"
    },
    {
      id: 19249,
      question: "According to beneficence, the care plan must:",
      options: [
        "Be identical for all patients",
        "Use evidence-based strategies to promote oral health and wellness",
        "Focus only on cost reduction",
        "Prioritize office efficiency"
      ],
      correct: "B"
    },
    {
      id: 19250,
      question: "Nonmaleficence means:",
      options: [
        "Maximizing profit",
        "Doing no harm",
        "Quick treatment",
        "Expensive care"
      ],
      correct: "B"
    },
    {
      id: 19251,
      question: "Respecting patient autonomy in planning means:",
      options: [
        "The clinician makes all decisions",
        "Including the patient in planning and decision-making",
        "Ignoring patient preferences",
        "Following only insurance guidelines"
      ],
      correct: "B"
    },
    {
      id: 19252,
      question: "Risk management strategies for record keeping include:",
      options: [
        "Destroying records immediately",
        "Complying with state regulations for storage and confidentiality",
        "Sharing records publicly",
        "Keeping no records"
      ],
      correct: "B"
    },
    {
      id: 19253,
      question: "Patient confidentiality means:",
      options: [
        "Anyone can access patient records",
        "Protecting and respecting the privacy of patient information",
        "Posting patient information online",
        "Discussing patients in public"
      ],
      correct: "B"
    },
    {
      id: 19254,
      question: "Which model suggests setting goals before selecting interventions?",
      options: [
        "Medical Model",
        "Human Needs Conceptual Model",
        "Nursing Model",
        "Insurance Model"
      ],
      correct: "B"
    },
    {
      id: 19255,
      question: "Which model suggests developing treatment strategies before setting goals?",
      options: [
        "Human Needs Conceptual Model",
        "OHRQL Model",
        "Medical Model",
        "Financial Model"
      ],
      correct: "B"
    },
    {
      id: 19256,
      question: "Person-centered care requires:",
      options: [
        "Treating all patients the same",
        "Individualizing care to support unique needs, values, and abilities",
        "Following only insurance protocols",
        "Minimizing patient involvement"
      ],
      correct: "B"
    },
    {
      id: 19257,
      question: "The link between diagnosis, goals, and interventions is:",
      options: [
        "Unnecessary",
        "Critical to care plan outcomes",
        "Only for documentation purposes",
        "Optional"
      ],
      correct: "B"
    },
    {
      id: 19258,
      question: "When should the care plan be presented to the patient?",
      options: [
        "After all treatment is complete",
        "Before preventive and therapeutic services are implemented",
        "Only if the patient asks",
        "Never"
      ],
      correct: "B"
    },
    {
      id: 19259,
      question: "A cotherapeutic relationship means:",
      options: [
        "The clinician tells the patient what to do",
        "Collaborative engagement between patient and clinician",
        "The patient has no input",
        "Only the dentist is involved"
      ],
      correct: "B"
    },
    {
      id: 19260,
      question: "When discussing multiple diagnoses, it is best to:",
      options: [
        "Discuss all at once quickly",
        "Focus on one condition at a time for patient understanding",
        "Skip explanations",
        "Use only technical terminology"
      ],
      correct: "B"
    },
    {
      id: 19261,
      question: "Alternative treatment options should be discussed:",
      options: [
        "Never",
        "When available and of equal merit",
        "Only if cheaper",
        "After treatment begins"
      ],
      correct: "B"
    },
    {
      id: 19262,
      question: "If a patient refuses care that is necessary, the clinician should:",
      options: [
        "Proceed anyway",
        "Document the refusal and discuss consequences",
        "Discharge immediately without discussion",
        "Ignore the refusal"
      ],
      correct: "B"
    },
    {
      id: 19263,
      question: "Motivational interviewing brings the patient into conversation about:",
      options: [
        "Office policies",
        "Behavior change",
        "Financial matters only",
        "Staff schedules"
      ],
      correct: "B"
    },
    {
      id: 19264,
      question: "SBIRT stands for:",
      options: [
        "Simple Behavioral Intervention and Referral Treatment",
        "Screening, Brief Intervention, and Referral to Treatment",
        "Standard Baseline Interaction and Routine Testing",
        "Special Brushing Instruction and Reinforcement Technique"
      ],
      correct: "B"
    },
    {
      id: 19265,
      question: "The AUDIT questionnaire screens for:",
      options: [
        "Financial problems",
        "Alcohol use disorders",
        "Hearing problems",
        "Anxiety disorders"
      ],
      correct: "B"
    },
    {
      id: 19266,
      question: "According to the 2021 Surgeon General report, which type of measures should be emphasized?",
      options: [
        "Only biological measures",
        "Biopsychosocial measures in person-centered care",
        "Only psychosocial measures",
        "Financial measures only"
      ],
      correct: "B"
    },
    {
      id: 19267,
      question: "How many aspects are outlined in ADHA Standard 2 for dental hygiene diagnosis?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six"
      ],
      correct: "C"
    },
    {
      id: 19268,
      question: "Standard 2 requires the dental hygienist to analyze and interpret:",
      options: [
        "Insurance benefits",
        "Assessment data using evidence-based critical analysis",
        "Office schedules",
        "Fee structures"
      ],
      correct: "B"
    },
    {
      id: 19269,
      question: "The dental hygiene diagnosis provides the basis for:",
      options: [
        "Insurance billing only",
        "The dental hygiene care plan",
        "Office marketing",
        "Staff scheduling"
      ],
      correct: "B"
    },
    {
      id: 19270,
      question: "The dental hygiene diagnosis is complementary to:",
      options: [
        "Nothing else",
        "The dental diagnosis",
        "Insurance codes only",
        "Office policies exclusively"
      ],
      correct: "B"
    },
    {
      id: 19271,
      question: "Dental hygiene diagnosis promotes:",
      options: [
        "Competition among providers",
        "Collaboration within dentistry and with other healthcare professionals",
        "Isolation of practice",
        "Reduced communication"
      ],
      correct: "B"
    },
    {
      id: 19272,
      question: "In states with direct access, dental hygienists may:",
      options: [
        "Only work under direct supervision",
        "Initiate treatment based on assessment without specific dentist authorization",
        "Not provide any services",
        "Only clean instruments"
      ],
      correct: "B"
    },
    {
      id: 19273,
      question: "The Flint, Michigan water crisis is an example of:",
      options: [
        "Good public health policy",
        "Environmental factors requiring modified oral hygiene approaches",
        "Dental hygiene scope exceeding bounds",
        "Unnecessary public concern"
      ],
      correct: "B"
    },
    {
      id: 19274,
      question: "What caused cognitive deficits in the Flint water crisis?",
      options: [
        "Fluoride",
        "Lead contamination",
        "Chlorine",
        "Hard water"
      ],
      correct: "B"
    },
    {
      id: 19275,
      question: "Direct access means the dental hygienist can:",
      options: [
        "Only schedule appointments",
        "Initiate treatment based on assessment",
        "Perform surgery",
        "Prescribe any medication"
      ],
      correct: "B"
    },
    {
      id: 19276,
      question: "How many states had direct access in 2000?",
      options: [
        "2",
        "8",
        "20",
        "42"
      ],
      correct: "B"
    },
    {
      id: 19277,
      question: "Which organization removed dental hygiene diagnosis from standards in 2010?",
      options: [
        "ADA",
        "ADHA",
        "CODA",
        "WHO"
      ],
      correct: "C"
    },
    {
      id: 19278,
      question: "The 2021 Surgeon General report supports:",
      options: [
        "Limited access to dental hygiene services",
        "Greater access to dental hygiene services",
        "Eliminating dental hygiene",
        "Dentist-only care"
      ],
      correct: "B"
    },
    {
      id: 19279,
      question: "What percentage of adults need some form of oral healthcare according to public health data?",
      options: [
        "25%",
        "50%",
        "75%",
        "Nearly 100%"
      ],
      correct: "D"
    },
    {
      id: 19280,
      question: "Professional liability insurance for dental hygienists:",
      options: [
        "Is unnecessary",
        "Is critical and should not rely solely on employer\'s insurance",
        "Is only for dentists",
        "Is illegal"
      ],
      correct: "B"
    },
    {
      id: 19281,
      question: "The National Practitioner Data Bank (NPDB) was established in:",
      options: [
        "1976",
        "1986",
        "1996",
        "2006"
      ],
      correct: "B"
    },
    {
      id: 19282,
      question: "What does NPDB track?",
      options: [
        "Continuing education credits",
        "Malpractice payments and adverse actions",
        "Salary information",
        "Vacation time"
      ],
      correct: "B"
    },
    {
      id: 19283,
      question: "Basic beliefs in the ADHA Code of Ethics include:",
      options: [
        "Dental hygiene care is separate from overall healthcare",
        "Dental hygiene care is an essential component of overall healthcare",
        "Only dentists provide important care",
        "Patients should not be involved in decisions"
      ],
      correct: "B"
    },
    {
      id: 19284,
      question: "According to ADHA ethics, dental hygienists should:",
      options: [
        "Work in isolation",
        "Function interdependently with other providers",
        "Never consult with others",
        "Only follow dentist orders"
      ],
      correct: "B"
    },
    {
      id: 19285,
      question: "Scope of practice for dental hygienists:",
      options: [
        "Is identical in all states",
        "Varies by state",
        "Does not exist",
        "Is federally mandated with no variation"
      ],
      correct: "B"
    },
    {
      id: 19286,
      question: "Why is it important to research state practice acts?",
      options: [
        "It\'s not important",
        "To understand what is legally permitted in that state",
        "For entertainment",
        "To avoid all treatment"
      ],
      correct: "B"
    },
    {
      id: 19287,
      question: "Medical malpractice liability for dental hygienists:",
      options: [
        "Does not exist",
        "Can occur, such as for untreated periodontal disease",
        "Only applies to dentists",
        "Is covered by patients\' insurance"
      ],
      correct: "B"
    },
    {
      id: 19288,
      question: "A dental hygienist can be held liable for:",
      options: [
        "Nothing",
        "Untreated periodontal disease and other negligence",
        "Only criminal acts",
        "Weather conditions"
      ],
      correct: "B"
    },
    {
      id: 19289,
      question: "What organization offers approved professional liability insurance for dental hygienists?",
      options: [
        "ADA only",
        "ADHA",
        "State boards only",
        "No organization offers this"
      ],
      correct: "B"
    },
    {
      id: 19290,
      question: "Why should dental hygienists maintain their own liability insurance?",
      options: [
        "It\'s not necessary",
        "Employer coverage may not adequately protect the individual hygienist",
        "It\'s too expensive",
        "It\'s illegal"
      ],
      correct: "B"
    },
    {
      id: 19291,
      question: "Collaboration with the dentist during care planning ensures:",
      options: [
        "Increased conflict",
        "Mutually supportive dental and dental hygiene plans",
        "Slower care",
        "Higher costs only"
      ],
      correct: "B"
    },
    {
      id: 19292,
      question: "Teledentistry provides opportunities for:",
      options: [
        "Eliminating dental hygienists",
        "Similar coordination of patient care",
        "Reducing quality of care",
        "Avoiding all patient contact"
      ],
      correct: "B"
    },
    {
      id: 19293,
      question: "When formulating a care plan without dentist access, the dental hygienist should:",
      options: [
        "Not provide any care",
        "Base the plan on assessment findings and diagnosis, and refer as needed",
        "Guess at treatment",
        "Wait indefinitely"
      ],
      correct: "B"
    },
    {
      id: 19294,
      question: "If urgent dental or medical needs are identified, the dental hygienist should:",
      options: [
        "Ignore them",
        "Refer for assessment and treatment prior to or with dental hygiene services",
        "Treat all conditions independently",
        "Send the patient home"
      ],
      correct: "B"
    },
    {
      id: 19295,
      question: "The continued-care visit begins with:",
      options: [
        "Cleaning only",
        "Assessment and evaluation to measure continued goal attainment",
        "Scheduling the next visit",
        "Payment collection"
      ],
      correct: "B"
    },
    {
      id: 19296,
      question: "At the continued-care visit, measuring previous care plan goals helps:",
      options: [
        "Fill time",
        "Ensure long-term adherence and recognize recurrence of problems",
        "Increase costs",
        "Confuse the patient"
      ],
      correct: "B"
    },
    {
      id: 19297,
      question: "If a previous need recurs at the continued-care visit, the dental hygienist should:",
      options: [
        "Ignore it",
        "Investigate the underlying contributor and continue the process of care",
        "Blame the patient",
        "Provide no further care"
      ],
      correct: "B"
    },
    {
      id: 19298,
      question: "Quality assurance audits of patient records help:",
      options: [
        "Criticize clinicians",
        "Ensure adherence to legal and ethical standards",
        "Waste time",
        "Increase liability"
      ],
      correct: "B"
    },
    {
      id: 19299,
      question: "When an error is made in electronic documentation, the proper procedure is to:",
      options: [
        "Delete the entire record",
        "Mark it as a mistaken entry, add correct information, date and initial",
        "Ignore it",
        "Start a new patient file"
      ],
      correct: "B"
    },
    {
      id: 19300,
      question: "The phrase \"goal met at each appointment\" means:",
      options: [
        "Goals were never evaluated",
        "The patient consistently achieved the stated goal",
        "The goal was inappropriate",
        "No progress was made"
      ],
      correct: "B"
    },
    {
      id: 19301,
      question: "When a patient demonstrates \"adequate\" brushing technique, this means:",
      options: [
        "Perfect technique",
        "Acceptable but may benefit from minor improvements",
        "Poor technique",
        "No technique"
      ],
      correct: "B"
    },
    {
      id: 19302,
      question: "The purpose of applying a disclosing agent is to:",
      options: [
        "Whiten teeth",
        "Make plaque visible for assessment and patient education",
        "Numb tissues",
        "Remove stain"
      ],
      correct: "B"
    },
    {
      id: 19303,
      question: "\"Localized plaque retentive sites\" refers to:",
      options: [
        "No plaque present",
        "Specific areas where plaque accumulates more easily",
        "General plaque throughout the mouth",
        "Calculus only"
      ],
      correct: "B"
    },
    {
      id: 19304,
      question: "When should a power brush be introduced to a patient?",
      options: [
        "Immediately at first visit",
        "After demonstrating manual technique and assessing patient readiness",
        "Never",
        "Only if the patient specifically requests it"
      ],
      correct: "B"
    },
    {
      id: 19305,
      question: "\"Phase I response to nonsurgical therapy\" means:",
      options: [
        "The patient refused treatment",
        "Evaluation of healing and outcomes after initial periodontal therapy",
        "The first appointment",
        "Surgical procedures"
      ],
      correct: "B"
    },
    {
      id: 19306,
      question: "A reevaluation is typically scheduled how long after completing Phase I therapy?",
      options: [
        "1-2 days",
        "4-6 weeks",
        "6 months",
        "1 year"
      ],
      correct: "B"
    },
    {
      id: 19307,
      question: "If residual deposits are found at reevaluation, the appropriate action is:",
      options: [
        "Ignore them",
        "Debride the residual deposits",
        "Schedule surgery immediately",
        "Discharge the patient"
      ],
      correct: "B"
    },
    {
      id: 19308,
      question: "Coronal polish is used to:",
      options: [
        "Replace scaling",
        "Remove extrinsic stain after debridement",
        "Treat periodontitis",
        "Diagnose caries"
      ],
      correct: "B"
    },
    {
      id: 19309,
      question: "Medium grit paste is used for:",
      options: [
        "Sensitive teeth",
        "Removing moderate extrinsic stain",
        "Deplaquing",
        "All polishing situations"
      ],
      correct: "B"
    },
    {
      id: 19310,
      question: "Air powder polishing is an alternative to:",
      options: [
        "Flossing",
        "Rubber cup polishing for stain removal",
        "Scaling",
        "Brushing"
      ],
      correct: "B"
    },
    {
      id: 19311,
      question: "What concentration of sodium fluoride varnish is commonly used?",
      options: [
        "1.1%",
        "2.26%",
        "5%",
        "10%"
      ],
      correct: "C"
    },
    {
      id: 19312,
      question: "Why was the patient scheduled for a periodontist consultation in the case examples?",
      options: [
        "As a routine referral for all patients",
        "Due to localized moderate bone loss and critical pocket depths",
        "For extractions",
        "For orthodontics"
      ],
      correct: "B"
    },
    {
      id: 19313,
      question: "Patient-centered outcomes focus on:",
      options: [
        "Clinical measurements only",
        "Patient behaviors, skills, and adherence to recommendations",
        "Office efficiency only",
        "Cost savings"
      ],
      correct: "B"
    },
    {
      id: 19314,
      question: "Clinical outcomes focus on:",
      options: [
        "Patient satisfaction only",
        "Signs and symptoms of disease and desired oral health status",
        "Appointment length",
        "Payment methods"
      ],
      correct: "B"
    },
    {
      id: 19315,
      question: "Short-term goals are typically evaluated:",
      options: [
        "After 5 years",
        "Within the active treatment phase",
        "Never",
        "Before treatment starts"
      ],
      correct: "B"
    },
    {
      id: 19316,
      question: "Long-term goals are typically evaluated:",
      options: [
        "At the first appointment",
        "At continued-care visits",
        "Never",
        "Only when the patient asks"
      ],
      correct: "B"
    }
  ],

  "1. Care Planning, Evaluation, and Documentation (Case Study)": [
    {
      id: 20000,
      question: "Based on Maria's case, which dental hygiene diagnosis using the Human Needs Conceptual Model BEST addresses her periodontal condition?",
      options: [
        "Unmet need for skin and mucous membrane integrity due to inadequate oral self-care as evidenced by generalized gingivitis",
        "Unmet need for biologically sound dentition due to xerostomia and diet as evidenced by high caries risk",
        "Unmet need for conceptualization due to knowledge deficit as evidenced by patient misconceptions about disease",
        "Unmet need for wholesome facial image due to gingival inflammation as evidenced by patient dissatisfaction with appearance",
      ],
      correct: "A"
    },
    {
      id: 20001,
      question: "When establishing care plan goals for Maria, which goal statement demonstrates the MOST appropriate structure and measurability?",
      options: [
        "Patient will understand the importance of daily plaque removal and demonstrate improved oral hygiene practices",
        "Patient will reduce bleeding index to less than 15% by Phase I reevaluation on specified date",
        "Patient will have healthier gums and better diabetes control through consistent self-care efforts",
        "Patient will eliminate gingival inflammation and stabilize periodontal condition within reasonable timeframe",
      ],
      correct: "B"
    },
    {
      id: 20002,
      question: "During care plan presentation, Maria expresses concern about the cost of multiple treatment appointments. What is the dental hygienist's MOST appropriate initial response?",
      options: [
        "Immediately refer Maria to the office manager to discuss payment plans before continuing the care plan discussion",
        "Acknowledge her concern, explain consequences of untreated periodontal disease, and discuss alternative treatment options",
        "Suggest delaying treatment until she has dental insurance or sufficient funds to cover all appointments",
        "Simplify the treatment plan to one prophylaxis appointment to address her financial limitations",
      ],
      correct: "B"
    },
    {
      id: 20003,
      question: "Jamie is a 10-year-old male presenting with his mother for a routine appointment. Medical history shows recently diagnosed Type 2 diabetes (HbA1c 7.5%). Oral examination reveals high caries risk with active occlusal caries on teeth #19 and #30, deep pits and fissures on teeth #3 and #14, generalized heavy biofilm, and plaque-free score of 50%. His mother reports Jamie brushes once daily and prefers sweetened drinks and snacks between meals. Periodontal evaluation shows healthy gingiva with no significant findings. Using the OHRQL Model, what represents the PRIMARY etiology for Jamie's high caries risk?",
      options: [
        "Deep occlusal pits and fissures in molars combined with existing active carious lesions on posterior teeth",
        "Generalized heavy biofilm, low plaque-free score, and brushing frequency of only once daily",
        "Mother's meal preparation choices, frequency of cariogenic diet, and child's preference for sweetened beverages",
        "Recent diabetes diagnosis with HbA1c of 7.5% and inadequate systemic disease management by physician",
      ],
      correct: "C"
    },
    {
      id: 20004,
      question: "Which intervention strategy should be included in Jamie's care plan to address the PRIMARY modifiable risk factor?",
      options: [
        "Immediate placement of pit and fissure sealants on teeth #3 and #14 before any restorative treatment",
        "Prescription-strength sodium fluoride toothpaste for daily application with twice-daily brushing frequency",
        "Dietary guidance with motivational interviewing to assist parent and child in selecting healthier food choices",
        "Comprehensive oral hygiene instruction demonstrating proper brushing technique and interdental cleaning methods",
      ],
      correct: "C"
    },
    {
      id: 20005,
      question: "When formulating patient-centered goals for Jamie, which goal demonstrates appropriate categorization as an AFFECTIVE goal?",
      options: [
        "Patient will demonstrate proper brushing technique with fluoride toothpaste twice daily by end of treatment",
        "Patient will increase plaque-free index score from 50% to 85% by six-month continued care visit",
        "Patient will verbalize understanding of caries process and relationship between diet and cavity formation",
        "Patient will complete pit and fissure sealant placement on teeth #3 and #14 by specified appointment date",
      ],
      correct: "D"
    },
    {
      id: 20006,
      question: "At Jamie's Phase I reevaluation, his plaque-free score improved to 85% and he reports brushing twice daily. However, his mother states they \"haven't really changed our snacking habits yet.\" What is the MOST appropriate documentation of goal achievement?",
      options: [
        "Goal met for oral health status; patient successfully reduced caries risk from high to low by increasing protective factors",
        "Goal partially met for affective domain; patient improved oral hygiene but family dietary patterns remain unchanged",
        "Goal not met for cognitive understanding; patient lacks comprehension of relationship between diet and dental caries",
        "Goal met for psychomotor skills; patient demonstrates adequate brushing frequency despite continued dietary risk factors",
      ],
      correct: "B"
    },
    {
      id: 20007,
      question: "Robert is a 56-year-old male returning for Phase I reevaluation 6 weeks after completing scaling and root planing. Previous diagnosis was Stage III/Grade C periodontitis with 5-7mm probing depths, generalized horizontal bone loss, HbA1c 7.5%, and hypertension. Initial care plan goals included: reducing probing depths ≥5mm by at least 1mm, reducing bleeding index to <10%, eliminating gingival inflammation, and patient adherence to daily brushing with powered toothbrush and flossing. At reevaluation, clinical findings show: probing depths reduced to 3-4mm (7mm sites now 5mm), bleeding index 13% (primarily maxillary molars), localized inflammation at maxillary molars, and plaque index 9.8%. Robert reports daily powered toothbrush use and flossing, purchased recommended oral hygiene aids, and scheduled Phase II evaluation with periodontist. Which evaluation statement MOST accurately reflects Robert's goal achievement for reducing probing depths?",
      options: [
        "Goal met; all probing depths ≥5mm reduced by minimum 1mm with 7mm sites showing 2mm reduction",
        "Goal partially met; most sites improved but localized areas maintain 5mm depths requiring additional treatment",
        "Goal not met; patient continues to demonstrate probing depths exceeding 4mm in multiple sites",
        "Goal exceeded; patient achieved greater reduction than anticipated with excellent prognosis for maintenance",
      ],
      correct: "A"
    },
    {
      id: 20008,
      question: "Robert's bleeding index of 13% represents which evaluation outcome for the goal of reducing bleeding to less than 10%?",
      options: [
        "Goal met because bleeding index decreased significantly from initial 68% showing substantial improvement",
        "Goal partially met because bleeding reduced dramatically but did not achieve the specified target criteria",
        "Goal not met because bleeding index exceeds the defined measurable criterion of less than 10%",
        "Goal exceeded because localization of bleeding to maxillary molars indicates contained inflammatory response",
      ],
      correct: "C"
    },
    {
      id: 20009,
      question: "Based on Robert's reevaluation findings, what should be the dental hygienist's NEXT course of action?",
      options: [
        "Terminate care plan, schedule 3-month maintenance, and document that all goals successfully achieved",
        "Retreat maxillary molars with additional scaling, modify self-care instruction, and reschedule reevaluation",
        "Document partial goal achievement, reinforce interdental cleaning at molars, proceed with scheduled periodontist evaluation",
        "Modify care plan goals to reflect realistic expectations, extend reevaluation period, and discontinue specialist referral",
      ],
      correct: "C"
    },
    {
      id: 20010,
      question: "What prognosis statement is MOST appropriate for Robert's long-term periodontal health?",
      options: [
        "Prognosis is excellent due to significant pocket reduction and patient's demonstrated commitment to oral self-care",
        "Prognosis is good because patient achieved most clinical goals and maintains regular professional care appointments",
        "Prognosis is fair due to diabetes with HbA1c 7.5%, age factors, and localized moderate bone loss",
        "Prognosis is poor because patient failed to achieve all defined goals and maintains systemic risk factors",
      ],
      correct: "C"
    },
    {
      id: 20011,
      question: "Sandra is a 45-year-old female presenting for initial examination. Assessment reveals Stage II/Grade B periodontitis with 4-6mm probing depths, moderate bone loss, 55% bleeding index, and heavy calculus. Medical history shows controlled hypertension. The dental hygienist presents a care plan including patient education, four quadrants of scaling and root planing with local anesthesia, and 3-month maintenance intervals. Sandra states she \"just wants a cleaning\" and doesn't want \"all those extra appointments.\" According to informed consent principles, what information is MOST critical to discuss with Sandra?",
      options: [
        "Detailed fee schedule for scaling and root planing compared to prophylaxis to address her financial concerns",
        "Alternative treatment options of equal merit, if available, or limitations of prophylaxis for periodontal disease",
        "Consequences of untreated periodontal disease including potential tooth loss and systemic health implications",
        "Testimonials from other patients who successfully completed similar treatment plans and achieved positive outcomes",
      ],
      correct: "C"
    },
    {
      id: 20012,
      question: "Sandra continues to decline the recommended scaling and root planing, insisting on prophylaxis only. What is the dental hygienist's MOST appropriate action?",
      options: [
        "Provide the requested prophylaxis to maintain the patient relationship and schedule follow-up in 6 months",
        "Refuse to provide any treatment until Sandra agrees to the recommended care plan for her condition",
        "Document informed refusal with patient signature, explain risks, and suggest seeking a second professional opinion",
        "Modify the care plan to provide prophylaxis with extended appointment time to address calculus removal",
      ],
      correct: "C"
    },
    {
      id: 20013,
      question: "Which documentation element is ESSENTIAL when Sandra refuses the recommended treatment?",
      options: [
        "Detailed explanation that the dental hygienist disagrees with patient's decision and cannot be held liable",
        "Brief explanation of recommended care, specific procedure declined, risks of non-treatment, date, and patient signature",
        "Comprehensive description of all possible complications including worst-case scenarios to protect practice legally",
        "Statement releasing the dental practice from any responsibility for future periodontal deterioration or tooth loss",
      ],
      correct: "B"
    },
    {
      id: 20014,
      question: "If Sandra later experiences periodontal disease progression, which documentation provides the STRONGEST legal protection for the dental hygienist?",
      options: [
        "Progress notes showing prophylaxis was provided at patient's request with no mention of treatment recommendations",
        "Signed informed refusal form with documented discussion of consequences and alternative treatment options",
        "Treatment plan showing scaling and root planing was recommended with notation that patient cancelled appointments",
        "Health history update form indicating patient was advised to seek treatment with a periodontal specialist",
      ],
      correct: "B"
    },
    {
      id: 20015,
      question: "Thomas is a 24-year-old male returning for 6-month continued care. Previous care plan addressed generalized moderate gingivitis with goals including: eliminate bleeding and inflammation, increase plaque-free score to 95%, and report daily brushing and flossing. At previous appointment, he demonstrated proper technique, understood disease process, and reported commitment to self-care. Current findings show: generalized moderate inflammation, bleeding index 45%, plaque-free score 60%, and continued 4mm probing depths. Thomas reports brushing twice daily and flossing every evening as instructed. Previous documentation shows education on gingivitis, technique demonstration on model, frequency instruction, and dispensing of soft-bristle brush and floss samples. What does Thomas's failure to achieve previous goals MOST likely indicate?",
      options: [
        "Patient lacks manual dexterity to perform proper oral hygiene techniques despite reported adherence to recommendations",
        "Previous care plan goals were unrealistic given patient's periodontal condition and insufficient time for improvement",
        "Underlying barrier exists between patient's reported behavior and actual oral hygiene practices performed at home",
        "Insufficient patient education was provided during previous appointment regarding disease etiology and prevention",
      ],
      correct: "C"
    },
    {
      id: 20016,
      question: "Which assessment strategy would BEST identify the barrier to Thomas achieving care plan goals?",
      options: [
        "Demonstrate brushing and flossing techniques again on a model and observe patient's ability to replicate",
        "Apply disclosing solution and ask patient to demonstrate his actual home care routine intraorally",
        "Recommend powered toothbrush and interdental cleaning aids to improve mechanical plaque removal",
        "Educate patient again about gingivitis etiology and importance of consistent daily plaque biofilm disruption",
      ],
      correct: "B"
    },
    {
      id: 20017,
      question: "During continued care assessment, which finding provides evidence that Thomas successfully maintained a PREVIOUS care plan goal?",
      options: [
        "Patient verbalizes understanding of periodontal disease process and can identify plaque as the causative agent",
        "Probing depths remain at 4mm with no clinical attachment loss or radiographic bone changes",
        "Patient reports purchasing and consistently using recommended oral hygiene products at home",
        "Gingival inflammation remains generalized and moderate without progression to severe category",
      ],
      correct: "B"
    },
    {
      id: 20018,
      question: "Based on Thomas's current findings, what should be included in the NEW dental hygiene diagnosis?",
      options: [
        "Unmet need for conceptualization due to knowledge deficit as evidenced by inability to explain disease process",
        "Unmet need for responsibility for oral health due to inadequate technique as evidenced by current oral conditions",
        "Unmet need for skin and mucous membrane integrity due to non-adherence as evidenced by persistent inflammation",
        "Unmet need for biologically sound dentition due to systemic factors as evidenced by continued periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 20019,
      question: "Lisa is a 50-year-old female presenting as a new patient. She reports being widowed 2 years ago and managing a vintage boutique. Medical history reveals recent diagnoses: prediabetes (HbA1c 6.0%), hypertension, elevated cholesterol. Current medications include atorvastatin and Avapro. She reports smoking 3-4 cigarettes daily, frequently skipping lunch, ordering restaurant takeout, drinking 3-4 cups of coffee with milk daily, and weight gain over past year. Height 5'6\", weight 172 lbs. She states concern about recent health diagnoses and verbalizes need to \"get health back on track.\" Dental history shows no professional care in 4 years. She reports brushing once daily and occasional flossing. Oral assessment reveals moderate caries risk, periodontal risk factors, and Stage I/Grade B periodontitis. Chief concern: \"self-conscious about tooth appearance when smiling and long-time desire for straighter teeth.\" Which interprofessional collaboration is MOST critical to address Lisa's immediate health needs?",
      options: [
        "Referral to orthodontist to address chief concern of tooth malalignment and smile aesthetics",
        "Consultation with physician regarding blood pressure management and weight loss program effectiveness",
        "Coordination with registered dietitian for comprehensive nutrition counseling and meal planning",
        "Collaboration with behavioral health counselor to address grief management and lifestyle changes",
      ],
      correct: "C"
    },
    {
      id: 20020,
      question: "When developing Lisa's dental hygiene care plan, which intervention strategy demonstrates appropriate interprofessional collaboration?",
      options: [
        "Educating Lisa about the oral-systemic connection between periodontal disease and cardiovascular health",
        "Coordinating dental hygiene appointment schedule with her physician appointments for patient convenience",
        "Referring Lisa for medical evaluation of suspected undiagnosed conditions before providing dental hygiene services",
        "Consulting with physician to coordinate planning of dental hygiene care with comprehensive health needs",
      ],
      correct: "D"
    },
    {
      id: 20021,
      question: "Which dental hygiene diagnosis BEST reflects Lisa's need for interprofessional care coordination?",
      options: [
        "Unmet need for protection from health risk due to multiple systemic conditions as evidenced by prediabetes and hypertension",
        "Unmet need for wholesome facial image due to tooth malalignment as evidenced by patient dissatisfaction with smile",
        "Unmet need for conceptualization due to knowledge deficit as evidenced by inadequate understanding of oral-systemic link",
        "Unmet need for biologically sound dentition due to inadequate professional care as evidenced by 4-year absence",
      ],
      correct: "A"
    },
    {
      id: 20022,
      question: "During care planning, Lisa mentions feeling that the dental hygienist is \"the only friend who always responds.\" What is the MOST appropriate professional response?",
      options: [
        "Express appreciation for the relationship while redirecting focus to today's treatment planning and oral health goals",
        "Acknowledge the value of conversations while directly stating limitations of the professional relationship",
        "Thank her for the compliment and continue with care plan presentation without addressing the comment",
        "Suggest she may benefit from additional support and provide contact information for counseling services",
      ],
      correct: "B"
    },
    {
      id: 20023,
      question: "The dental hygienist is developing a care plan for a patient with generalized slight gingivitis, inadequate home care (PI 50%, no interdental cleaning), and healthy periodontium (normal bone, full dentition). The patient demonstrates lack of knowledge about periodontal disease, plaque biofilm, and importance of daily oral hygiene. Using the OHRQL Model, biofilm is identified as primary etiology with inadequate home care as the risk factor. Which goal statement represents an appropriately written COGNITIVE goal?",
      options: [
        "Patient will describe periodontal disease etiology and identify bacterial plaque biofilm as causative agent by treatment end",
        "Patient will demonstrate proper interdental cleaning technique using dental floss at all appointments",
        "Patient will reduce plaque index from 50% to less than 10% by next continued care visit",
        "Patient will eliminate gingival inflammation and bleeding on probing by next maintenance appointment",
      ],
      correct: "A"
    },
    {
      id: 20024,
      question: "For the same patient, which goal statement represents an appropriately written PSYCHOMOTOR goal?",
      options: [
        "Patient will verbalize understanding of the relationship between plaque biofilm and gingival inflammation",
        "Patient will demonstrate proper flossing technique using C-shaped method by end of treatment appointment",
        "Patient will value the importance of daily oral hygiene and commit to twice-daily brushing routine",
        "Patient will reduce bleeding index to less than 15% by Phase I reevaluation on specified date",
      ],
      correct: "B"
    },
    {
      id: 20025,
      question: "Which goal statement for this patient demonstrates an appropriately written ORAL HEALTH STATUS goal?",
      options: [
        "Patient will perform daily interdental cleaning using dental floss with proper C-shaped technique",
        "Patient will understand importance of disrupting bacterial plaque biofilm to prevent periodontal disease",
        "Patient will eliminate gingival inflammation and achieve healthy periodontal tissues by next continued care visit",
        "Patient will report adherence to recommended twice-daily brushing and once-daily flossing by reevaluation",
      ],
      correct: "C"
    },
    {
      id: 20026,
      question: "When writing care plan goals, which component is MOST essential for establishing measurable outcomes?",
      options: [
        "Subject identifying the patient as the person responsible for achieving the goal",
        "Verb identifying the specific action the patient will demonstrate upon goal achievement",
        "Criterion establishing the observable behavior or tangible outcome that will be measured",
        "Time dimension denoting the specific date or appointment when goal achievement will be evaluated",
      ],
      correct: "C"
    },
    {
      id: 20027,
      question: "A 56-year-old female patient presents with high caries risk due to: frequent cariogenic/acidogenic diet, postmenopausal xerostomia, inadequate salivary flow, and recurrent caries on multiple teeth. She reports brushing twice daily with fluoride toothpaste and daily interdental cleaning. Risk assessment shows disease indicator of recurrent caries, multiple risk factors, and few protective factors. Using the Human Needs Conceptual Model, what is the MOST appropriate unmet need statement?",
      options: [
        "Unmet need for conceptualization and problem-solving due to knowledge deficit of caries process",
        "Unmet need for biologically sound and functional dentition due to diet and xerostomia",
        "Unmet need for responsibility for oral health due to inadequate oral self-care practices",
        "Unmet need for skin and mucous membrane integrity due to reduced salivary flow",
      ],
      correct: "B"
    },
    {
      id: 20028,
      question: "For this patient using the Human Needs Conceptual Model, which goal statement is MOST appropriately linked to the diagnosis?",
      options: [
        "Patient will report satisfaction with recommended self-care strategies for dry mouth management by specified date",
        "Patient will demonstrate effective oral hygiene techniques including interdental cleaning by next appointment",
        "Patient will verbalize understanding of the relationship between diet and dental caries by treatment end",
        "Patient will schedule and complete comprehensive examination with physician to address xerostomia etiology",
      ],
      correct: "A"
    },
    {
      id: 20029,
      question: "Which intervention strategy using the Human Needs Conceptual Model BEST addresses the etiology of this patient's caries risk?",
      options: [
        "Comprehensive oral hygiene instruction focusing on proper brushing technique with fluoride toothpaste",
        "Dietary guidance to assist in selecting dental-healthy food choices and limiting frequency of consumption",
        "Professional application of fluoride varnish at each appointment to increase protective factors",
        "Referral to dentist for immediate restorative treatment of all recurrent carious lesions",
      ],
      correct: "B"
    },
    {
      id: 20030,
      question: "Using the OHRQL Model approach, what represents the PRIMARY difference in care plan development sequence?",
      options: [
        "Treatment interventions are selected first, followed by collaborative goal-setting discussions with the patient",
        "Patient goals are established first, followed by selection of evidence-based intervention strategies",
        "Dental hygiene diagnosis is formulated first, followed by prioritization of treatment needs",
        "Assessment data is collected first, followed by analysis and interpretation of clinical findings",
      ],
      correct: "A"
    },
    {
      id: 20031,
      question: "A patient requires comprehensive Phase I therapy including: patient education on periodontal disease, dietary guidance, smoking cessation counseling, oral hygiene instruction for powered toothbrush and interdental aids, fluoride therapy, scaling and root planing in four quadrants with local anesthesia, and desensitization therapy. The patient has limited schedule flexibility due to work constraints. When developing the appointment schedule, which factor should be given HIGHEST priority?",
      options: [
        "Grouping all educational interventions into the first appointment before beginning any clinical procedures",
        "Scheduling sufficient time to ensure patient comfort including pain management and anxiety control",
        "Completing all four quadrants of scaling and root planing in minimum number of appointments",
        "Arranging appointments during morning hours when patient typically demonstrates better tolerance",
      ],
      correct: "B"
    },
    {
      id: 20032,
      question: "How should self-care education be BEST sequenced throughout this patient's treatment appointments?",
      options: [
        "Dedicate entire first appointment to comprehensive education before beginning any treatment procedures",
        "Include small increments of instruction at each visit to shape patient's self-care responsibilities progressively",
        "Provide all education materials at initial appointment for patient to review independently at home",
        "Schedule self-care instruction at end of each treatment appointment as time permits",
      ],
      correct: "B"
    },
    {
      id: 20033,
      question: "For a patient requiring Phase I therapy, which intervention should be scheduled at the FIRST treatment appointment?",
      options: [
        "Scaling and root planing of the most severely affected quadrant with deepest probing depths",
        "Comprehensive periodontal reevaluation to establish accurate baseline before treatment begins",
        "Patient education about disease etiology with establishment of oral hygiene improvement goals",
        "Application of professional fluoride varnish to address identified moderate to high caries risk",
      ],
      correct: "C"
    },
    {
      id: 20034,
      question: "When should the Phase I reevaluation appointment be scheduled after completing scaling and root planing?",
      options: [
        "Immediately at the next appointment to assess tissue response and modify care plan promptly",
        "At 4-6 weeks to allow adequate healing time and measure achievement of clinical goals",
        "At 3 months to coincide with typical continued care interval and evaluate long-term outcomes",
        "At patient's convenience within 2-8 weeks based on scheduling availability and preferences",
      ],
      correct: "B"
    },
    {
      id: 20035,
      question: "A dental hygienist completes Phase I nonsurgical periodontal therapy for a patient with Stage III/Grade C periodontitis. The appointment included: medical history review, vital signs, preprocedural chlorhexidine rinse, assessment of tissue response to previous quadrant scaling, reinforcement of powered toothbrush technique, local anesthesia (2% lidocaine with 1:100,000 epinephrine, 3 cartridges), ultrasonic and hand instrumentation scaling and root planing of quadrants 2 and 3, and postoperative instructions. Which CDT code is MOST appropriate for documenting this service?",
      options: [
        "D1110 - Prophylaxis, adult, to indicate thorough cleaning of all tooth surfaces",
        "D4341 - Periodontal scaling and root planing, four or more teeth per quadrant",
        "D4910 - Periodontal maintenance to document continued care following active therapy",
        "D4346 - Scaling in presence of generalized moderate or severe gingival inflammation",
      ],
      correct: "B"
    },
    {
      id: 20036,
      question: "Which element is MOST critical to include in the progress note documentation for this appointment?",
      options: [
        "Detailed description of ultrasonic instrumentation tips used and hand instrument sharpening procedures",
        "Complete list of all possible postoperative complications discussed with patient including worst-case scenarios",
        "Specific type, agent, concentration, number of cartridges, and location of local anesthesia administered",
        "Comprehensive explanation of periodontal disease etiology and all risk factors discussed with patient",
      ],
      correct: "C"
    },
    {
      id: 20037,
      question: "At the Phase I reevaluation, goals were partially met with localized inflammation remaining. What should be documented?",
      options: [
        "General statement that goals were achieved and patient is progressing satisfactorily toward maintenance",
        "Specific evaluative statement identifying which goals were met, partially met, or not met with supporting evidence",
        "Brief notation that reevaluation was completed with recommendation for continued care in 3 months",
        "Detailed description of all clinical procedures performed during reevaluation appointment",
      ],
      correct: "B"
    },
    {
      id: 20038,
      question: "If the dental hygienist discovers an error in a previously stored electronic progress note, what is the MOST appropriate correction method?",
      options: [
        "Delete the incorrect entry completely and create a new entry with accurate information",
        "Mark entry as mistaken, add correct information, and date and initial the correction",
        "Override the previous entry by entering new information without notation of error",
        "Contact office manager to have IT department remove erroneous information from system",
      ],
      correct: "B"
    },
    {
      id: 20039,
      question: "A dental hygiene student is reviewing the ADHA Standards for Clinical Dental Hygiene Practice to ensure proper application throughout the process of care. The student is working with a patient who has completed assessment and dental hygiene diagnosis, and is now ready for care plan development. According to ADHA Standard 3 (Planning), which activity is the DEFINING characteristic of this step?",
      options: [
        "Collection and analysis of comprehensive patient data to identify oral health problems and risk factors",
        "Formulation of diagnostic statements that identify patient needs amenable to dental hygiene care",
        "Prioritization of diagnosed needs and establishment of patient goals with selected intervention strategies",
        "Implementation of preventive, educational, and therapeutic services to address identified patient needs",
      ],
      correct: "C"
    },
    {
      id: 20040,
      question: "During the planning step, the dental hygienist must ensure the care plan meets specific characteristics. Which characteristic is MOST essential?",
      options: [
        "Care plan reflects general preventive services that would be appropriate for most patients with similar conditions",
        "Care plan identifies relationships among dental hygiene diagnoses, patient-centered goals, and selected interventions",
        "Care plan includes detailed description of all possible treatment options regardless of patient need or priority",
        "Care plan demonstrates clinician's expertise and technical skills in providing comprehensive dental hygiene services",
      ],
      correct: "B"
    },
    {
      id: 20041,
      question: "According to ADHA Standard 5 (Evaluation), what is the PRIMARY purpose of this step in the process of care?",
      options: [
        "Collection of comprehensive clinical and radiographic data to formulate accurate dental hygiene diagnoses",
        "Implementation of preventive and therapeutic interventions to address patient's identified oral health needs",
        "Measurement of extent to which patient achieved goals defined in the dental hygiene care plan",
        "Documentation of all services rendered in chronological order with dates and provider signatures",
      ],
      correct: "C"
    },
    {
      id: 20042,
      question: "Which statement BEST describes the relationship between evaluation and other steps in the process of care?",
      options: [
        "Evaluation occurs only at completion of planned dental hygiene care to determine final outcomes",
        "Evaluation is integrated throughout all steps to monitor progress and make evidence-based decisions",
        "Evaluation is a separate distinct step performed independently from assessment and implementation",
        "Evaluation requires complete reassessment using identical methodology as initial data collection",
      ],
      correct: "B"
    },
    {
      id: 20043,
      question: "Following Phase I therapy completion, the dental hygienist is determining the prognosis for three different patients to establish appropriate continued care intervals. Patient A: All goals met, healthy periodontium restored, excellent oral hygiene, non-smoker, no systemic conditions Patient B: Goals met, periodontal health achieved, but patient has uncontrolled diabetes (HbA1c 9.2%) and smokes Patient C: Goals partially met, localized inflammation persists, moderate bone loss, controlled hypertension Which patient has an EXCELLENT prognosis for long-term periodontal health maintenance?",
      options: [
        "Patient A because all goals were achieved with no systemic or environmental risk factors present",
        "Patient B because clinical goals were met despite systemic conditions indicating effective treatment",
        "Patient C because periodontal maintenance therapy will address localized inflammation over time",
        "All patients have excellent prognosis because they completed recommended Phase I therapy successfully",
      ],
      correct: "A"
    },
    {
      id: 20044,
      question: "Which patient requires the SHORTEST continued care interval due to prognosis considerations?",
      options: [
        "Patient A with 6-month interval due to excellent prognosis and low risk for disease recurrence",
        "Patient B with 3-month interval due to high systemic risk factors despite achieving clinical goals",
        "Patient C with 4-month interval due to partially met goals requiring close monitoring",
        "All patients should receive 6-month intervals as standard continued care protocol",
      ],
      correct: "B"
    },
    {
      id: 20045,
      question: "For Patient B, which statement MOST accurately describes the appropriate prognosis designation?",
      options: [
        "Prognosis is excellent because patient achieved all defined care plan goals at Phase I reevaluation",
        "Prognosis is good because patient demonstrates commitment to oral self-care and treatment adherence",
        "Prognosis is guarded because high risk for disease recurrence exists due to uncontrolled diabetes and smoking",
        "Prognosis is poor because patient will likely experience rapid periodontal deterioration requiring surgical intervention",
      ],
      correct: "C"
    },
    {
      id: 20046,
      question: "What is the PRIMARY factor that distinguishes a \"favorable\" prognosis from a \"guarded\" prognosis?",
      options: [
        "Whether patient successfully achieved all care plan goals during active Phase I therapy",
        "Patient's level of compliance with recommended oral hygiene practices and professional care",
        "Risk level for new disease or recurrence of previous condition based on modifiable/non-modifiable factors",
        "Number of appointments required to achieve desired clinical outcomes and patient satisfaction",
      ],
      correct: "C"
    },
    {
      id: 20047,
      question: "A dental hygienist established the following care plan goals for a patient with generalized moderate gingivitis: - Cognitive goal: Patient will verbalize periodontal disease process and identify plaque as causative agent by 9/21 - Psychomotor goal: Patient will demonstrate proper interdental cleaning technique by 7/12 - Affective goal: Patient will report adherence to daily oral hygiene regimen by reevaluation - Oral health status goal: Patient will eliminate gingival inflammation by end of treatment on 9/10 Which evaluation strategy is MOST appropriate for measuring the cognitive goal achievement?",
      options: [
        "Ask patient to demonstrate proper brushing and flossing techniques intraorally using their own oral hygiene aids",
        "Ask patient open-ended questions to measure acquisition and comprehension of new knowledge",
        "Measure plaque index and gingival index to assess patient's application of learned information",
        "Review patient's written journal documenting daily oral hygiene practices and frequency",
      ],
      correct: "B"
    },
    {
      id: 20048,
      question: "At the 7/12 appointment, the patient has difficulty positioning the interdental aid in most areas. What is the MOST appropriate evaluative statement?",
      options: [
        "Goal met: Patient demonstrated proper technique in accessible areas showing adequate skill acquisition",
        "Goal partially met: Patient understood the concept but requires additional practice for skill mastery",
        "Goal not met: Patient is having difficulty positioning the interdental aid in most areas of mouth",
        "Goal deferred: Patient requires extended time to develop proper technique before evaluation",
      ],
      correct: "C"
    },
    {
      id: 20049,
      question: "To evaluate the affective goal, which assessment strategy provides the STRONGEST evidence of goal achievement?",
      options: [
        "Ask patient to report on their actual daily oral hygiene practices including frequency and products used",
        "Observe patient's nonverbal communication and attitude during oral hygiene instruction sessions",
        "Measure plaque index to determine effectiveness of patient's reported oral hygiene adherence",
        "Review patient's purchase history for recommended oral hygiene products from office dispensary",
      ],
      correct: "A"
    },
    {
      id: 20050,
      question: "At reevaluation, gingival findings support health with no inflammation or bleeding. Which evaluative statement is MOST appropriate?",
      options: [
        "Goal met on 9/10: Gingival findings support health with complete resolution of inflammation",
        "Goal exceeded on 9/10: Patient achieved health ahead of projected timeline showing excellent response",
        "Goal partially met on 9/10: Inflammation eliminated but bleeding index remains at 5% indicating residual disease",
        "Goal met on 9/10: Patient successfully demonstrated commitment to oral self-care resulting in improved health",
      ],
      correct: "A"
    },
    {
      id: 20051,
      question: "A patient's initial care plan goals included: reduce probing depths ≥5mm by 1mm, achieve bleeding index <10%, and daily adherence to powered toothbrush and flossing. At 6-week reevaluation: probing depths reduced appropriately, bleeding index 18% (localized to molars), patient reports daily compliance with oral hygiene. Previous education included technique demonstration, frequency instruction, and product dispensing. Based on these findings, what is the MOST appropriate clinical decision?",
      options: [
        "Terminate care plan because probing depth goal achieved indicating successful treatment outcome",
        "Continue current care plan unchanged because patient needs more time to achieve all goals",
        "Modify care plan to address localized barrier preventing bleeding index goal achievement",
        "Refer to periodontist because patient failed to achieve bleeding index goal indicating treatment failure",
      ],
      correct: "C"
    },
    {
      id: 20052,
      question: "What is the MOST likely barrier preventing this patient from achieving the bleeding index goal?",
      options: [
        "Patient lacks understanding of periodontal disease etiology despite previous comprehensive education",
        "Patient demonstrates inadequate manual dexterity to perform proper interdental cleaning techniques",
        "Patient has ineffective interdental cleaning specifically in molar regions despite reported daily compliance",
        "Patient requires more aggressive professional therapy including antimicrobial therapy or surgical intervention",
      ],
      correct: "C"
    },
    {
      id: 20053,
      question: "Which intervention strategy would BEST address the identified barrier?",
      options: [
        "Provide comprehensive education again about gingivitis etiology and importance of plaque biofilm removal",
        "Apply disclosing solution at molar areas and have patient demonstrate actual interdental cleaning technique intraorally",
        "Recommend alternative interdental cleaning device such as interdental brushes instead of dental floss",
        "Schedule additional scaling appointment to remove residual calculus deposits in posterior regions",
      ],
      correct: "B"
    },
    {
      id: 20054,
      question: "If the patient continues to not meet the bleeding index goal after appropriate intervention, what should the dental hygienist do?",
      options: [
        "Modify the goal to reflect more realistic expectations (e.g., bleeding index <20% instead of <10%)",
        "Reassess for additional contributing factors such as systemic conditions, medications, or anatomical variations",
        "Continue current care plan indefinitely until patient successfully achieves the originally defined goal",
        "Document goal as not achievable due to patient non-compliance and proceed to maintenance phase",
      ],
      correct: "B"
    },
    {
      id: 20055,
      question: "A 27-year-old female presents for initial examination. Medical history shows good health with no medications. She doesn't smoke or use tobacco. She brushes once daily with non-fluoride toothpaste using medium-bristle brush and states \"flossing makes gums bleed\" so she doesn't floss. Diet includes fruits, vegetables, chicken, fish, nuts, and she frequently sips sweet herbal iced tea throughout the day. Clinical findings: full dentition, no caries, moderate caries risk, generalized moderate gingivitis (Modified GI 3), 3-4mm probing depths, normal bone patterns, healthy attachment levels, BI 73%, PI 64%, supragingival calculus lingual sextant, and extrinsic brown stain. Which is the MOST appropriate diagnosis using the OHRQL Model?",
      options: [
        "Moderate caries risk due to frequent sweet tea consumption, absence of fluoride toothpaste use",
        "Generalized moderate gingivitis due to infrequent brushing, absence of interdental cleaning, generalized biofilm",
        "High risk for periodontal disease due to bleeding gums, inadequate oral hygiene, and calculus deposits",
        "Oral health concerns due to aesthetic issues from extrinsic stain and patient dissatisfaction with appearance",
      ],
      correct: "B"
    },
    {
      id: 20056,
      question: "For this patient, which represents the PRIMARY modifiable risk factor that should be addressed?",
      options: [
        "Infrequent brushing (once daily) with non-fluoride toothpaste using medium-bristle brush",
        "Complete absence of interdental cleaning due to misconception that flossing causes bleeding",
        "Frequent consumption of sweetened beverages throughout day contributing to caries risk",
        "Presence of extrinsic brown stain affecting patient's confidence and smile aesthetics",
      ],
      correct: "B"
    },
    {
      id: 20057,
      question: "Which intervention strategy should be included in the care plan to address BOTH the periodontal condition and caries risk?",
      options: [
        "Professional prophylaxis with thorough calculus removal and polishing to eliminate stain",
        "Comprehensive dietary analysis and counseling to reduce frequency of sweetened beverage consumption",
        "Oral hygiene instruction for twice-daily brushing with fluoride toothpaste and daily interdental cleaning",
        "Application of professional fluoride varnish to address moderate caries risk and strengthen enamel",
      ],
      correct: "C"
    },
    {
      id: 20058,
      question: "What CDT code is MOST appropriate for documenting this patient's treatment?",
      options: [
        "D1110 - Prophylaxis, adult, because patient has no history of periodontal disease or attachment loss",
        "D4346 - Scaling in presence of moderate gingival inflammation, because patient has generalized gingivitis",
        "D4910 - Periodontal maintenance, because patient requires continued care following initial treatment",
        "D4341 - Periodontal scaling and root planing, because patient has probing depths of 3-4mm",
      ],
      correct: "B"
    },
    {
      id: 20059,
      question: "A 58-year-old male presents for continued care. Medical history includes: coronary artery disease with previous myocardial infarction, Type 2 diabetes (HbA1c 8.2%), hypertension, hyperlipidemia, chronic kidney disease (Stage 3), and obstructive sleep apnea using CPAP. Current medications include: clopidogrel (Plavix), metformin, lisinopril, atorvastatin, and aspirin. Previous periodontal diagnosis: Stage III/Grade C periodontitis with 3-month maintenance intervals. Before beginning treatment, which assessment is MOST critical for this patient?",
      options: [
        "Comprehensive review of all medications, dosages, and adherence patterns to ensure accurate health history",
        "Detailed dietary analysis to address multiple systemic conditions affected by nutritional intake",
        "Current glycemic control status and confirmation of meal consumption to prevent hypoglycemic emergency",
        "Blood pressure measurement and consultation with physician regarding anticoagulant therapy management",
      ],
      correct: "C"
    },
    {
      id: 20060,
      question: "This patient's systemic conditions place him at highest risk for which oral-systemic complication?",
      options: [
        "Rapid progression of periodontal disease due to impaired immune response and inflammatory burden",
        "Delayed healing following dental hygiene procedures due to compromised renal function",
        "Excessive bleeding during instrumentation due to antiplatelet medication therapy",
        "Cardiovascular emergency during appointment due to stress and anxiety response",
      ],
      correct: "A"
    },
    {
      id: 20061,
      question: "When developing the care plan, which intervention demonstrates BEST practice for interprofessional collaboration?",
      options: [
        "Educating patient about oral-systemic connections between periodontal disease and his systemic conditions",
        "Referring patient to physician for medical clearance before providing any dental hygiene services",
        "Consulting with nephrologist regarding appropriate antibiotic prophylaxis protocol for kidney disease",
        "Coordinating with physician to support dental hygiene care planning with patient's comprehensive health needs",
      ],
      correct: "D"
    },
    {
      id: 20062,
      question: "What is the MOST appropriate continued care interval for this patient?",
      options: [
        "6-month intervals because patient has completed Phase I therapy and achieved periodontal health",
        "3-month intervals due to high-risk systemic conditions and history of Stage III/Grade C periodontitis",
        "2-month intervals because multiple systemic conditions require intensive professional monitoring",
        "4-month intervals to balance patient's systemic risk factors with standard maintenance protocols",
      ],
      correct: "B"
    },
    {
      id: 20063,
      question: "An 8-year-old child presents with parent for initial examination. Medical history shows ADHD managed with methylphenidate. Oral assessment reveals: high caries risk with active caries on teeth #A, #K, and #S, deep pits and fissures, heavy biofilm (PI 70%), and child reports brushing \"sometimes\" without parental supervision. Parent reports frequent consumption of juice and snacks. Periodontal tissues show health. Child displays anxiety about dental appointment and difficulty sitting still. When planning care for this patient, which factor requires HIGHEST priority consideration?",
      options: [
        "Completing comprehensive treatment in minimum number of appointments to reduce child's anxiety exposure",
        "Scheduling appointments during optimal time when medication is most effective for behavior management",
        "Including parent actively in care planning, education, and skill-building for home care supervision",
        "Referring to pediatric dentist for comprehensive care due to child's special needs and multiple caries",
      ],
      correct: "C"
    },
    {
      id: 20064,
      question: "Which goal is MOST appropriate to establish with the parent for this patient?",
      options: [
        "Parent will report supervising child's twice-daily brushing with fluoride toothpaste by next appointment",
        "Child will independently perform proper oral hygiene without parental supervision by next appointment",
        "Parent will eliminate all juice and snacks from child's diet to reduce caries risk immediately",
        "Child will sit calmly for 60-minute appointments without displaying anxiety or movement",
      ],
      correct: "A"
    },
    {
      id: 20065,
      question: "When providing oral hygiene instruction for this patient, which strategy is MOST effective?",
      options: [
        "Demonstrate proper technique on model and provide detailed verbal instructions for child to follow",
        "Show educational video about cavities and brushing while child sits in dental chair",
        "Have child practice proper brushing technique in mouth while parent observes and receives instruction",
        "Provide written instructions and diagrams for parent to review with child at home",
      ],
      correct: "C"
    },
    {
      id: 20066,
      question: "Which intervention addresses the PRIMARY modifiable risk factor for this child's high caries risk?",
      options: [
        "Professional fluoride varnish application at each appointment to increase protective factors",
        "Pit and fissure sealant placement on all posterior teeth to provide physical barrier",
        "Dietary counseling with parent about reducing frequency of juice and snack consumption",
        "Prescription-strength fluoride toothpaste to compensate for inconsistent brushing habits",
      ],
      correct: "C"
    },
    {
      id: 20067,
      question: "A 35-year-old Hispanic male presents as new patient. He reports seeking dental care independently, stating \"professional oral health care not a cultural norm in my family.\" Last dental visit was 4 years ago. Assessment reveals: Stage III/Grade C periodontitis, generalized 4-6mm probing depths with localized 7mm depths on teeth #1 and #14, moderate bone loss, PI 85%, brushing twice daily with medium brush, flossing 2-3 times per week, and highly motivated to improve oral health. When presenting the care plan, which approach demonstrates BEST cultural competency?",
      options: [
        "Acknowledge patient's cultural background while emphasizing importance of regular professional care",
        "Explain that modern dental care standards require more frequent visits than his cultural practices",
        "Praise patient for seeking care independently and support his autonomy in making health decisions",
        "Recommend patient educate family members about importance of professional oral health care",
      ],
      correct: "C"
    },
    {
      id: 20068,
      question: "Which factor represents the GREATEST strength in this patient's prognosis for successful treatment outcomes?",
      options: [
        "Patient's young age suggesting better healing capacity and lower risk for disease progression",
        "Patient's self-initiated care-seeking behavior indicating high motivation to improve oral health",
        "Patient's existing oral hygiene practices including twice-daily brushing and frequent flossing",
        "Patient's lack of systemic conditions that could complicate periodontal therapy or healing",
      ],
      correct: "B"
    },
    {
      id: 20069,
      question: "When establishing care plan goals, which approach is MOST appropriate for this patient?",
      options: [
        "Set aggressive goals to compensate for patient's previous 4-year absence from professional care",
        "Collaborate with patient to establish goals that align with his values and readiness to change",
        "Establish standard goals based on clinical findings without discussing cultural considerations",
        "Modify goals to accommodate patient's cultural perspective on oral health care importance",
      ],
      correct: "B"
    },
    {
      id: 20070,
      question: "At Phase I reevaluation, patient achieved all clinical goals. For continued care planning, what should be emphasized?",
      options: [
        "Importance of maintaining regular professional care despite cultural norms in patient's family",
        "Patient's success in achieving health and value of his commitment to oral self-care practices",
        "Need for patient to overcome cultural barriers that previously prevented regular dental visits",
        "Recommendation that patient encourage family members to seek professional dental care",
      ],
      correct: "B"
    },
    {
      id: 20071,
      question: "A dental hygiene practice is transitioning from paper records to an electronic health record (EHR) system. The dental hygienists are learning to document services using CDT codes, customized electronic notes, and narrative supplemental entries. Which represents the PRIMARY advantage of EHR documentation for interprofessional patient care?",
      options: [
        "Reduced time spent on documentation allowing more time for direct patient care and education",
        "Elimination of documentation errors through automated templates and standardized entry fields",
        "Real-time availability of patient information to interprofessional care team for coordinated services",
        "Improved legal protection through comprehensive digital record keeping with backup systems",
      ],
      correct: "C"
    },
    {
      id: 20072,
      question: "When documenting in the EHR, which entry provides the MOST complete evidence of patient-centered care?",
      options: [
        "CDT code D4341 entered for each quadrant of scaling and root planing completed",
        "Customized note \"Phase I therapy completed\" with date, provider signature, and patient signature",
        "Narrative description including assessment findings, interventions, patient response, and outcomes",
        "Standardized template with checkboxes for services completed and products dispensed",
      ],
      correct: "C"
    },
    {
      id: 20073,
      question: "A dental hygienist needs to document informed consent for Phase I periodontal therapy. Which method provides STRONGEST legal documentation?",
      options: [
        "Progress note stating \"care plan presented and patient agreed to recommended treatment\"",
        "Electronic signature on customized consent form with documented discussion of risks and benefits",
        "Email correspondence with patient confirming appointment dates for scaling and root planing",
        "Checked box in assessment form indicating \"informed consent obtained\" with provider initials",
      ],
      correct: "B"
    },
    {
      id: 20074,
      question: "Which documentation practice represents the MOST significant risk management concern?",
      options: [
        "Using standardized abbreviations from facility's approved list to reduce documentation time",
        "Entering CDT codes without supplemental narrative describing specific patient care details",
        "Documenting services several hours after completion based on memory and chart records",
        "Including objective clinical findings without documenting subjective patient complaints",
      ],
      correct: "C"
    },
    {
      id: 20075,
      question: "A dental hygienist has completed assessment for a patient with Stage II periodontitis requiring scaling and root planing. The collaborating dentist recommends providing only prophylaxis because the patient is \"price-sensitive\" and \"won't accept expensive treatment anyway.\" The dental hygienist believes the patient needs and would benefit from appropriate periodontal therapy. Which ethical principle is MOST relevant to this situation?",
      options: [
        "Autonomy requiring respect for patient's right to make informed decisions about treatment",
        "Beneficence requiring provision of care that promotes patient's oral health and well-being",
        "Nonmaleficence requiring avoidance of harm including under-treatment of disease",
        "Justice requiring fair allocation of resources and equal access to appropriate care",
      ],
      correct: "B"
    },
    {
      id: 20076,
      question: "What is the dental hygienist's MOST appropriate initial action in this situation?",
      options: [
        "Defer to dentist's recommendation and provide prophylaxis as instructed to maintain employment",
        "Present accurate diagnosis and appropriate treatment recommendation to patient for informed consent",
        "Refuse to provide prophylaxis and insist patient must receive scaling and root planing instead",
        "Discuss concerns with dentist privately and advocate for patient's right to appropriate care",
      ],
      correct: "D"
    },
    {
      id: 20077,
      question: "If the dentist insists on prophylaxis only, what is the dental hygienist's ethical obligation?",
      options: [
        "Provide prophylaxis as directed while documenting that dentist made this treatment decision",
        "Present accurate diagnosis and appropriate treatment options to patient regardless of dentist's directive",
        "Resign from position rather than participate in care that doesn't meet professional standards",
        "Report dentist to state board for unethical practice of under-treating patients due to cost",
      ],
      correct: "B"
    },
    {
      id: 20078,
      question: "Which documentation would provide BEST protection if this patient later experiences periodontal disease progression?",
      options: [
        "Progress note stating \"provided prophylaxis as recommended by doctor despite periodontitis diagnosis\"",
        "Informed consent with documented discussion of periodontitis, recommended treatment, and patient's decision",
        "Notation that \"patient declined recommended scaling and root planing due to cost concerns\"",
        "Detailed description of dentist's treatment decision including rationale for prophylaxis instead of SRP",
      ],
      correct: "B"
    },
    {
      id: 20079,
      question: "A 42-year-old female returns for 3-month periodontal maintenance following successful Phase I therapy. Previous diagnosis: Stage II/Grade B periodontitis. All previous goals were met at Phase I reevaluation. Current assessment reveals: new 5mm probing depths on teeth #3 and #14 (previously 3mm), localized bleeding at these sites, PI 15% (localized to posterior areas), patient reports \"being less careful\" with flossing past few weeks due to work stress. This patient's current findings represent which outcome related to previous care plan goals?",
      options: [
        "Goals continue to be met because patient maintained most areas of periodontal health",
        "Goals partially met because localized areas show evidence of disease recurrence",
        "Goals not met because any disease recurrence indicates treatment failure",
        "New goals needed because previous care plan goals only applied to active therapy phase",
      ],
      correct: "B"
    },
    {
      id: 20080,
      question: "Which represents the MOST appropriate new dental hygiene diagnosis for this patient?",
      options: [
        "Unmet need for freedom from stress due to work demands as evidenced by reduced oral hygiene adherence",
        "Unmet need for skin and mucous membrane integrity due to inadequate interdental cleaning as evidenced by localized disease",
        "Unmet need for conceptualization due to knowledge deficit as evidenced by failure to maintain health",
        "Unmet need for biologically sound dentition due to disease recurrence as evidenced by new probing depths",
      ],
      correct: "B"
    },
    {
      id: 20081,
      question: "What intervention strategy should be included in today's supportive care plan?",
      options: [
        "Complete periodontal examination and charting to establish new baseline measurements for future comparison",
        "Comprehensive education about periodontal disease etiology and risk factors as if patient is newly diagnosed",
        "Localized periodontal debridement at affected sites with reinforcement of interdental cleaning technique",
        "Referral to periodontist for evaluation because patient demonstrates disease recurrence despite maintenance",
      ],
      correct: "C"
    },
    {
      id: 20082,
      question: "What is the MOST appropriate continued care interval for this patient going forward?",
      options: [
        "Maintain 3-month interval because localized disease recurrence indicates need for continued close monitoring",
        "Extend to 4-month interval because most areas demonstrate health showing generally good oral hygiene",
        "Reduce to 2-month interval due to work stress affecting oral hygiene and risk for further recurrence",
        "Extend to 6-month interval after patient demonstrates improved adherence to interdental cleaning",
      ],
      correct: "A"
    },
    {
      id: 20083,
      question: "A 29-year-old male presents for continued care. Previous goals included reducing PI from 65% to <10%, daily brushing and flossing, and eliminating gingivitis. Current findings: PI 55%, inconsistent interdental cleaning, persistent generalized gingivitis. Patient states \"I know I should floss but I'm just too busy and usually forget.\" Which motivational interviewing question is MOST effective to assess patient's readiness to change?",
      options: [
        "\"Why don't you set a reminder on your phone to help you remember to floss daily?\"",
        "\"On a scale of 0-10, how important is it to you to improve your gum health?\"",
        "\"Don't you understand that not flossing is causing your gums to remain inflamed?\"",
        "\"What would it take for you to commit to flossing at least once every day?\"",
      ],
      correct: "B"
    },
    {
      id: 20084,
      question: "The patient responds that improving gum health is \"about a 7\" in importance. What is the BEST follow-up question?",
      options: [
        "\"That's great that it's important to you! So when will you start flossing daily?\"",
        "\"Why isn't it a 10? What would make improving your gum health more important?\"",
        "\"What makes it a 7 for you rather than a lower number like a 3 or 4?\"",
        "\"A 7 isn't high enough. Let me explain again why flossing is critically important.\"",
      ],
      correct: "C"
    },
    {
      id: 20085,
      question: "Which intervention strategy demonstrates BEST application of motivational interviewing principles?",
      options: [
        "Explain consequences of not flossing including progression to periodontitis and potential tooth loss",
        "Demonstrate proper flossing technique again and emphasize importance of daily adherence",
        "Explore barriers to flossing and collaborate with patient to identify realistic solutions",
        "Set specific goal for flossing frequency and schedule follow-up to assess compliance",
      ],
      correct: "C"
    },
    {
      id: 20086,
      question: "At next continued care visit, patient reports flossing \"a few times a week\" with PI improved to 35%. What response is MOST appropriate?",
      options: [
        "\"That's not good enough. You need to floss every single day to achieve healthy gums.\"",
        "\"I notice improvement in your plaque score. Tell me what helped you increase your flossing.\"",
        "\"You're still not meeting your goal. What's preventing you from flossing daily?\"",
        "\"Let's focus on the areas where you're still missing. Show me how you're flossing.\"",
      ],
      correct: "B"
    },
    {
      id: 20087,
      question: "A 16-year-old patient with cerebral palsy presents with parent/caregiver for initial examination. Patient uses wheelchair, has limited upper extremity control, and is non-verbal but cognitively intact. Assessment reveals: high caries risk, multiple active caries, moderate gingivitis, heavy biofilm (PI 80%), and parent reports difficulty performing oral care for patient due to muscle spasticity and tactile sensitivity. Which represents the PRIMARY barrier to this patient achieving oral health?",
      options: [
        "Patient's inability to independently perform oral hygiene due to limited upper extremity control",
        "Parent's inadequate technique and difficulty managing patient's muscle spasticity during care",
        "Patient's cognitive inability to understand importance of oral hygiene and disease prevention",
        "Patient's lack of access to appropriate adaptive oral hygiene devices for special needs",
      ],
      correct: "B"
    },
    {
      id: 20088,
      question: "When formulating care plan goals, who should be identified as the SUBJECT of patient-centered goals?",
      options: [
        "Patient as the individual responsible for achieving improved oral health outcomes",
        "Parent/caregiver as the person responsible for performing oral hygiene care",
        "Dental hygienist as the professional responsible for providing preventive services",
        "Interdisciplinary care team as collective responsible for supporting patient needs",
      ],
      correct: "B"
    },
    {
      id: 20089,
      question: "Which intervention strategy would MOST effectively address the primary barrier?",
      options: [
        "Referral to occupational therapist for adaptive equipment to enable patient independence",
        "Hands-on instruction with parent demonstrating positioning and techniques for managing spasticity",
        "Comprehensive education with patient about oral disease and importance of daily oral hygiene",
        "Recommendation for general anesthesia to provide necessary restorative and preventive care",
      ],
      correct: "B"
    },
    {
      id: 20090,
      question: "When documenting care planning for this patient, what is MOST important to include?",
      options: [
        "Detailed description of patient's disabilities and limitations affecting ability to maintain oral health",
        "Parent/caregiver involvement in goal setting, education, and assumption of oral hygiene responsibilities",
        "Recommendation for facility-based care due to complexity of patient's special healthcare needs",
        "Notation that standard care plan goals are not appropriate for patients with developmental disabilities",
      ],
      correct: "B"
    },
    {
      id: 20091,
      question: "A 4-year-old child presents with parent for initial examination. Assessment reveals: multiple early childhood caries, high caries risk, frequent consumption of juice and milk (including nighttime bottle), brushing inconsistently without fluoride toothpaste, and low socioeconomic status with limited access to fluoridated water. Parent works two jobs with limited time for meal preparation. Which factor represents the HIGHEST priority modifiable risk factor to address?",
      options: [
        "Nighttime bottle use with juice or milk providing frequent sugar exposure during sleep",
        "Inconsistent brushing practices without fluoride toothpaste or professional fluoride application",
        "Low socioeconomic status limiting access to healthy foods and fluoridated water",
        "Parent's limited time for meal preparation resulting in reliance on convenient processed foods",
      ],
      correct: "A"
    },
    {
      id: 20092,
      question: "Which intervention strategy is MOST appropriate for this family's circumstances?",
      options: [
        "Comprehensive dietary counseling requiring major changes to family's eating patterns and food choices",
        "Recommendation for intensive preventive program requiring frequent professional visits and applications",
        "Focused behavior modification for single highest-impact change: eliminating nighttime bottle",
        "Referral to social services for assistance with nutrition programs and access to healthier food options",
      ],
      correct: "C"
    },
    {
      id: 20093,
      question: "When establishing care plan goals with this parent, which approach demonstrates BEST understanding of family-centered care?",
      options: [
        "Set aggressive goals to quickly reverse caries risk due to child's young age and severity of condition",
        "Establish standard evidence-based goals regardless of family's socioeconomic circumstances",
        "Collaborate with parent to identify realistic goals considering family's resources and constraints",
        "Modify goals to lower standards acknowledging parent's limited ability to implement recommendations",
      ],
      correct: "C"
    },
    {
      id: 20094,
      question: "Which protective factor intervention is MOST feasible and high-impact for this patient?",
      options: [
        "Prescription-strength sodium fluoride toothpaste requiring parent to supervise twice-daily application",
        "Professional fluoride varnish application every 3 months combined with home fluoride supplements",
        "Installation of home water filtration system to ensure access to fluoridated water for family",
        "Comprehensive nutrition program with meal planning support and healthy food delivery services",
      ],
      correct: "B"
    },
    {
      id: 20095,
      question: "A 52-year-old female presents for continued care. Dental history includes dental implants #3, #14, #19, #30 placed 3 years ago. Current assessment reveals: natural teeth show healthy periodontium (3mm probing depths, no bleeding), but implant sites show peri-implant mucositis with 4-5mm probing depths, bleeding on probing around all implants, and heavy biofilm accumulation around implant crowns. Patient reports cleaning implants \"the same as natural teeth.\" What is the MOST appropriate diagnosis for this patient's implant condition?",
      options: [
        "Peri-implant mucositis due to inadequate oral hygiene as evidenced by biofilm and inflammation",
        "Peri-implantitis due to progressive bone loss as evidenced by increased probing depths",
        "Healthy implant tissues showing normal healing response to routine bacterial challenge",
        "Failed implant integration requiring referral for implant removal and replacement",
      ],
      correct: "A"
    },
    {
      id: 20096,
      question: "Which represents the PRIMARY difference between care for this patient's natural teeth versus implants?",
      options: [
        "Implants require more aggressive scaling and root planing to remove subgingival biofilm",
        "Implants require specialized instruments and techniques to avoid damaging implant surfaces",
        "Implants require antibiotic therapy due to higher risk of infection than natural teeth",
        "Implants require shorter continued care intervals regardless of natural teeth periodontal health",
      ],
      correct: "B"
    },
    {
      id: 20097,
      question: "Which intervention is MOST critical to include in this patient's care plan?",
      options: [
        "Education about differences between implant and natural tooth anatomy requiring modified home care",
        "Referral to oral surgeon for evaluation of possible implant failure and need for replacement",
        "Professional debridement of implant surfaces using stainless steel instruments and ultrasonic scalers",
        "Prescription for systemic antibiotics to address bacterial infection surrounding implant fixtures",
      ],
      correct: "A"
    },
    {
      id: 20098,
      question: "What continued care interval is MOST appropriate for this patient?",
      options: [
        "3-month intervals for all sites because implants require same maintenance as natural periodontium",
        "3-month intervals until implant tissues show health, then extend to 6 months for all sites",
        "2-month intervals for implant sites with 4-month intervals for natural teeth showing health",
        "6-month intervals because peri-implant mucositis is reversible and not serious condition",
      ],
      correct: "B"
    }
  ]
};
